/* ============================================================
   GREY HAIR SALON — Grey Blending consultation app
   Shopify theme asset. Firebase for data + photos.
   ------------------------------------------------------------
   EDIT THIS BLOCK ONLY. Everything below it is the app.
   ============================================================ */

const CONFIG = {

  // 1. Paste your Firebase web config here (Project settings > Your apps > Web)
  firebase: {
    apiKey:            "AIzaSyD2t2FfamcWYSAyi5lyOcPKEbXdeF3m5zo",
    authDomain:        "grey-blending-intake.firebaseapp.com",
    projectId:         "grey-blending-intake",
    storageBucket:     "grey-blending-intake.firebasestorage.app",
    messagingSenderId: "975918568434",
    appId:             "1:975918568434:web:169ae7fded86be8caad16b"
  },

  // 2. >>> THE ONLY LINE YOU HAVE TO EDIT <<<
  //     Put the app@greyhairsalon.com password on the "password" line below.
  //     Nobody types this. It is not anyone's login. Everything else in this
  //     file is already filled in for you.
  appAccount: {
    email: "app@greyhairsalon.com",
    password: "k4Jm9pQz7wRt2xLb8vNc"
  },

  // 3. Your team and their PINs. Edit freely — this is the only place they live.
  //    role "owner"  = sees the floor AND full client profiles
  //    role "stylist" = sees the floor only
  //    contacts: true = may see full phone numbers and email addresses.
  //                     Everyone else sees only the last 4 digits of the phone.
  //                     Add or remove this line per person as you like.
  staff: [
    { name: "Dreidy",     pin: "2636", role: "stylist" },
    { name: "Ledy",       pin: "1977", role: "stylist" },
    { name: "Anamary",    pin: "9110", role: "stylist" },
    // contacts:true = may see full phone numbers and email addresses.
    // Everyone else sees the client's name and the last 4 digits only.
    { name: "Gretell",    pin: "0710", role: "owner", title: "Master Hairstylist", contacts: true },
    { name: "Lina",       pin: "1319", role: "owner", contacts: true },
    { name: "Front Desk", pin: "6578", role: "owner" }
  ],

  // 4. Services you offer, grouped. Edit, add, remove or reorder freely —
  //    these become the checkboxes on the visit form. A stylist can tick
  //    as many as she did in one appointment.
  services: [
    { group: "Signature Styling", items: [
      "Signature Blowout (Short to Medium Hair)",
      "Signature Blowout (Long / Thick Hair)",
      "Signature Blowout — Weekday Special",
      "Signature Blowout — Weekday Special (Long/Thick)",
      "Signature Blowout w/ Gretell (Short/Med)",
      "Signature Blowout w/ Gretell (Long/Thick)",
      "Sleek Iron Finish Add-On (Short)",
      "Sleek Iron Finish Add-On (Medium)",
      "Sleek Iron Finish Add-On (Long)",
      "Curls & Waves Add-On (Short)",
      "Curls & Waves Add-On (Medium)",
      "Curls & Waves Add-On (Long)",
      "Blow Dry with Extensions (Short/Medium)",
      "Blow Dry with Extensions (Long/Thick)",
      "Taping Hair Extensions",
      "Hair Extensions Retape",
      "Assistance"
    ]},
    { group: "Color & Lightening", items: [
      "Permanent Root Color",
      "Permanent Root Color — Gretell",
      "Permanent Full Color — Short Hair",
      "Permanent Full Color",
      "Permanent Full Color — Short Hair (Gretell)",
      "Permanent Full Color — Gretell",
      "Demi-Permanent Root Color",
      "Demi-Permanent Root Color — Gretell",
      "Demi-Permanent Full Color — Short Hair",
      "Demi-Permanent Full Color",
      "Demi-Permanent Full Color — Short Hair (Gretell)",
      "Demi-Permanent Full Color — Gretell",
      "Men's Permanent Full Color",
      "Men's Permanent Full Color (Gretell)",
      "Men's Demi-Permanent Full Color",
      "Men's Demi-Permanent Full Color (Gretell)",
      "Partial Highlights — Junior Stylist",
      "Partial Highlights — Gretell",
      "Full Highlights — Junior Stylist",
      "Full Highlights — Gretell",
      "Balayage — Junior Stylist",
      "Balayage — Gretell",
      "Low Lights",
      "Toner / Gloss (up to 2 oz)",
      "Toner / Gloss (over 2 oz)",
      "Toner / Gloss",
      "Hair Color Emulsion",
      "Face Glow Contouring",
      "Grey Blending — Junior Stylist",
      "Grey Blending — Gretell",
      "Grey Blending Refresh",
      "Inverse Grey Blending",
      "Grey Blending Prep & Strength",
      "Assist in Grey Blending",
      "PCC Gray Reset",
      "PCC Color Reset",
      "Color Correction — Junior Stylist",
      "Color Correction — Gretell",
      "Consultation — Junior Stylist",
      "Consultation — Gretell",
      "Deposit for Service — Junior Stylist",
      "Deposit for Service — Gretell"
    ]},
    { group: "Precision Cuts", items: [
      "Style Cut",
      "Style Cut — Weekday Special (Short/Med)",
      "Style Cut — Weekday Special (Long/Thick)",
      "Master Signature Cut — Gretell",
      "Signature Trim"
    ]},
    { group: "Restorative Treatments", items: [
      "Hair Detox",
      "Smooth & Shine Anti-Frizz Treatment",
      "Hair Botox Treatment",
      "Hair Botox Repair Treatment",
      "Stem Cell Hydration Treatment (Short)",
      "Stem Cell Hydration Treatment (Medium)",
      "Stem Cell Hydration Treatment (Long)",
      "L'Oréal Absolut Repair Molecular Treatment",
      "Redken Acidic Bonding Repair Treatment",
      "Deep Conditioning + Extra Shine Treatment",
      "Rice Cream Hair Spa",
      "Coffee Detox Scrub",
      "L'Oréal Professionnel Keratin Alpha Sleek"
    ]}
  ],

  salonName: "Grey Hair Salon",

  // 5. Estimates · Estimados. Prices and rules used by "New estimate".
  //    Change a price here and every new estimate uses it.
  estimates: {
    // The Shopify page where the client opens her estimate (see install steps).
    pageUrl: "https://greyhairsalon.com/pages/mi-estimado",
    // Where the "Reservar mi cita" button sends her. WhatsApp by default —
    // swap in your booking link if you'd rather she books directly.
    reserveUrl: "https://wa.me/17867500639",
    sessionPrice: 250,      // retail, each PCC and each prep appointment
    // Standard BUNDLE rates. Used to fill in "PCCs and prep together" for you,
    // so nobody does the arithmetic. The client never sees these per-session
    // numbers — only the one combined figure.
    bundlePccPrice:  210,
    bundlePrepPrice: 195,
    // How the sessions are named on her estimate. Shown as "2 × PCC".
    pccLabel:  "PCC",
    prepLabel: "Grey Prep & Strength",
    // Default names for the two stylist options.
    // Names offered in the "stylist" box on the estimate form. Add or change
    // freely. Nothing is pre-selected — you pick who the price is for.
    stylists: ["Con Gretell", "Con nuestra estilista senior"],
    depositPct: 30,         // % of the bundle, paid before the first PCC
    financingPct: 7,        // Shop Pay fee, charged after the consultation credit
    // Main services. price = full price when paid on its own (null = type it each time).
    services: [
      { name: "Grey Blending",            price: 1800 },
      { name: "Grey Blending Correctivo", price: 1800 },
      { name: "French Blending",          price: null },
      { name: "Corrección de Color",      price: null }
    ],
    // Consultation credit that transfers to every option.
    consults: [
      { label: "Consulta con Gretell · $125 credit", credit: 125, with: "Gretell" },
      { label: "Consulta con estilista senior · $65 credit", credit: 65, with: "nuestra estilista senior" },
      { label: "Old $85 consultation deposit · no credit", credit: 0, with: "Gretell" }
    ],
    // Starting list for "What the main day includes". Edit per client in the form.
    includes: [
      "Corrección de color.",
      "Diseño individualizado de Grey Blending.",
      "Creación estratégica de claridad y oscuridad.",
      "Aclaración por secciones según la respuesta de cada zona del cabello.",
      "Integración del crecimiento natural y las canas.",
      "Tonalización personalizada.",
      "Tratamiento de proteína.",
      "Hidratación profunda.",
      "Sellado y acondicionamiento de la fibra capilar.",
      "Corte según necesidad.",
      "Peinado final.",
      "Productos de mantenimiento para llevar a casa."
    ]
  }
};

/* ============================================================
   FORM SCHEMA — the client questionnaire.
   req:true  = required.  Everything else is optional.
   To change a question, edit it here. Nothing else to touch.
   ============================================================ */

const YNM = [["Yes","Sí"],["No","No"],["Not sure","No estoy segura"]];
const YN  = [["Yes","Sí"],["No","No"]];

const INTAKE = [
{
  n:["Your details","Sus datos"],
  note:["We only use this to reach you about your appointment.",
        "Solo usamos esto para contactarla sobre su cita."],
  fields:[
    {k:"name",  t:"text", req:true, l:["First and last name","Nombre y apellidos"]},
    {k:"phone", t:"tel",  req:true, l:["Phone / WhatsApp","Teléfono / WhatsApp"]},
    {k:"email", t:"email",           l:["Email","Correo electrónico"]},
    {k:"city",  t:"text", req:true, l:["City you're coming from","Ciudad desde donde nos visita"]},
    {k:"first", t:"radio", inline:true, l:["Is this your first time with us?","¿Es su primera vez con nosotros?"], o:YN},
    {k:"heard", t:"radio", l:["How did you hear about us?","¿Cómo nos conoció?"], o:[
      ["Instagram","Instagram"],["TikTok","TikTok"],["Facebook","Facebook"],["Google","Google"],
      ["Someone referred me","Me recomendaron"],["I'm already a client","Ya soy clienta"],["Other","Otro"]]}
  ]
},
{
  n:["What you're hoping for","Lo que desea lograr"],
  note:["Pick as many as you like. There's no wrong answer here.",
        "Seleccione todas las que quiera. Aquí no hay respuestas incorrectas."],
  fields:[
    {k:"goals", t:"checks", req:true, l:["What's drawing you to Grey Blending?","¿Qué la motiva a hacerse un Grey Blending?"], o:[
      ["I want to stop covering my grays completely","Quiero dejar de cubrir mis canas completamente"],
      ["I want to begin my transition to natural hair","Quiero comenzar mi transición hacia mi cabello natural"],
      ["I want to blend my grays more elegantly","Quiero integrar mis canas de forma más elegante"],
      ["I want to color my hair less often","Quiero teñirme con menos frecuencia"],
      ["I want to gradually remove a dark color","Quiero eliminar progresivamente un color oscuro"],
      ["I want to look lighter or blonder","Quiero verme más clara o rubia"],
      ["I want to keep a good amount of darkness","Quiero conservar bastante oscuridad"],
      ["I want a salt-and-pepper result","Quiero un resultado tipo sal y pimienta"],
      ["I want my silver more visible","Quiero que mis canas se vean más"],
      ["I want to correct previous work","Quiero corregir un trabajo anterior"],
      ["Something else","Otra cosa"]]}
  ]
},
{
  n:["Your natural gray","Sus canas naturales"],
  fields:[
    {k:"grayVisible", t:"radio", l:["Are your natural grays visible right now?","¿Sus canas naturales están visibles actualmente?"], o:[
      ["Yes, quite visible","Sí, bastante"],["Only at the regrowth","Solo en el crecimiento"],
      ["Very little","Muy poco"],["No, fully covered","No, están completamente cubiertas"]]},
    {k:"regrowth", t:"radio", l:["Roughly how much natural regrowth do you have?","¿Cuánto crecimiento natural tiene aproximadamente?"], o:[
      ["Under 1/2 inch","Menos de 1/2 pulgada"],["1/2 to 1 inch","1/2 a 1 pulgada"],
      ["1 to 2 inches","1 a 2 pulgadas"],["2 to 4 inches","2 a 4 pulgadas"],
      ["Over 4 inches","Más de 4 pulgadas"],["Not sure","No sé"]]}
  ]
},
{
  n:["Color history","Historial de color"],
  note:["This is the section that matters most. Being accurate here is how your stylist keeps your hair safe.",
        "Esta es la sección más importante. Ser precisa aquí es lo que permite a su estilista cuidar su cabello."],
  fields:[
    {k:"hasColor", t:"radio", req:true, inline:true, l:["Do you currently have color on your hair?","¿Actualmente tiene color en el cabello?"], o:YNM},
    {k:"currentColor", t:"radio", l:["What color is on your hair now?","¿Qué color tiene ahora en el cabello?"], o:[
      ["Black","Negro"],["Very dark brown","Castaño muy oscuro"],["Brown","Castaño"],["Light brown","Castaño claro"],
      ["Dark blonde","Rubio oscuro"],["Blonde","Rubio"],["Very light blonde","Rubio muy claro"],["Red","Rojo"],
      ["Copper","Cobrizo"],["Fashion color","Fantasía"],["A mix of several","Mezcla de varios"],["Other","Otro"]]},
    {k:"lastRoot", t:"text", req:true, l:["When did you last color your roots?","¿Cuándo se aplicó color en la raíz por última vez?"],
      hint:["A month and year is fine.","Un mes y año es suficiente."]},
    {k:"product", t:"radio", l:["What product was used?","¿Qué producto se utilizó?"], o:[
      ["Permanent color","Tinte permanente"],["Demi-permanent","Demi-permanente"],["Semi-permanent","Semi-permanente"],
      ["Henna","Henna"],["Depositing shampoo or color","Shampoo o color depositante"],
      ["Box or drugstore dye","Tinte de caja o comercial"],["Professional product","Producto profesional"],["Not sure","No sé"]]},
    {k:"brand", t:"text", l:["Brand and shade, if you remember","Marca y tono, si lo recuerda"]},
    {k:"history3y", t:"textarea", req:true, l:["Every color you remember having in the last 3 years","Todos los colores que recuerda haber tenido en los últimos 3 años"],
      hint:["For example: black > brown > red > blonde","Por ejemplo: negro > castaño > rojo > rubio"]},
    {k:"black5y", t:"radio", req:true, inline:true, l:["Has your hair been black or very dark at any point in the last 5 years?","¿Ha tenido el cabello negro o muy oscuro en algún momento en los últimos 5 años?"], o:YNM},
    {k:"boxBlack", t:"radio", inline:true, l:["Have you used black box dye?","¿Ha usado tinte negro de caja?"], o:YNM},
    {k:"henna", t:"radio", req:true, inline:true, l:["Have you ever used henna?","¿Alguna vez usó henna?"], o:YNM},
    {k:"metallic", t:"radio", inline:true, l:["Have you used vegetable or metallic dyes, or anything you're unsure of?","¿Ha usado tintes vegetales, metálicos o algo cuyo contenido desconoce?"], o:YNM},
    {k:"whoApplies", t:"radio", l:["Who usually colors your hair?","¿Quién le aplica el color normalmente?"], o:[
      ["Always in a salon","Siempre en salón"],["Mostly in a salon","Principalmente en salón"],
      ["Mostly at home","Principalmente en casa"],["Always at home","Siempre en casa"],["A bit of both","Un poco de ambos"]]}
  ]
},
{
  n:["Lightening and bleach","Aclaración y decoloración"],
  fields:[
    {k:"bleached", t:"radio", req:true, inline:true, l:["Have you ever bleached your hair?","¿Alguna vez se ha decolorado el cabello?"], o:YNM},
    {k:"bleachWhat", t:"checks", l:["If yes, what was done? Pick all that apply.","Si respondió sí, ¿qué se realizó? Seleccione todas."], o:[
      ["Highlights","Highlights"],["Babylights","Babylights"],["Balayage","Balayage"],["Ombré","Ombré"],
      ["Full bleach","Decoloración completa"],["Money piece","Money piece"],["AirTouch","AirTouch"],
      ["Color removal or correction","Remoción o corrección de color"],["Grey Blending before","Grey Blending anteriormente"],["Other","Otro"]]},
    {k:"lastBleach", t:"text", l:["When was your last bleaching service?","¿Cuándo fue su última decoloración?"]},
    {k:"bleachDamage", t:"radio", inline:true, l:["Has your hair ever broken or burned after bleaching?","¿Alguna vez su cabello se partió o quemó después de una decoloración?"], o:YN},
    {k:"bleachDamageWhat", t:"textarea", l:["If yes, what happened?","Si respondió sí, ¿qué ocurrió?"]}
  ]
},
{
  n:["Straightening and other treatments","Alisados y otros tratamientos"],
  fields:[
    {k:"chem", t:"checks", req:true, l:["In the last 5 years, have you had any of these?","En los últimos 5 años, ¿se ha realizado alguno de estos?"], o:[
      ["Keratin","Keratina"],["Brazilian Blowout","Brazilian Blowout"],["Hair botox","Botox capilar"],
      ["Japanese straightening","Alisado japonés"],["Chemical relaxer","Relajante químico"],["Perm","Permanente"],
      ["Nanoplasty","Nanoplastia"],["Organic straightening","Alisado orgánico"],["Protein treatment","Tratamiento de proteínas"],
      ["Another chemical treatment","Otro tratamiento químico"],["None of these","Ninguno"]]},
    {k:"chemWhen", t:"textarea", l:["If you picked any, roughly when and how many times?","Si seleccionó alguno, ¿cuándo aproximadamente y cuántas veces?"]},
    {k:"chemBrand", t:"text", l:["Do you remember the brand?","¿Recuerda la marca?"]}
  ]
},
{
  n:["How your hair is doing","Estado de su cabello"],
  fields:[
    {k:"condition", t:"checks", l:["How would you describe your hair right now?","¿Cómo describiría su cabello ahora mismo?"], o:[
      ["Very healthy","Muy saludable"],["Healthy","Saludable"],["A little dry","Algo reseco"],["Very dry","Muy seco"],
      ["Fragile","Frágil"],["Breaks easily","Se parte fácilmente"],["Stretchy when wet","Elástico cuando está mojado"],
      ["Very porous","Muy poroso"],["Not sure","No estoy segura"]]},
    {k:"breakage", t:"radio", inline:true, l:["Noticed any breakage lately?","¿Ha notado rotura últimamente?"], o:YN},
    {k:"ends", t:"radio", inline:true, l:["Split or brittle ends?","¿Puntas abiertas o quebradizas?"], o:[["Yes","Sí"],["No","No"],["Some","Algunas"]]},
    {k:"gummy", t:"radio", inline:true, l:["Does your hair feel gummy or overly stretchy when wet?","¿Su cabello se siente como chicle o muy elástico cuando está mojado?"], o:YNM},
    {k:"cutLength", t:"radio", l:["Would you cut some length if it meant a healthier result?","¿Cortaría algo de largo si eso significara un resultado más saludable?"], o:[
      ["Yes","Sí"],["Depends how much","Depende de cuánto"],["I'd rather keep my length","Prefiero conservar mi largo"]]}
  ]
},
{
  n:["Scalp and safety","Cuero cabelludo y seguridad"],
  fields:[
    {k:"scalp", t:"radio", inline:true, l:["Any irritation, sores, or scalp conditions we should know about?","¿Alguna irritación, herida o condición del cuero cabelludo que debamos conocer?"], o:YN},
    {k:"scalpWhat", t:"textarea", l:["If yes, tell us briefly.","Si respondió sí, cuéntenos brevemente."]},
    {k:"allergy", t:"radio", req:true, inline:true, l:["Have you ever reacted badly to dye, bleach, or hair products?","¿Alguna vez ha reaccionado mal a tintes, decolorantes o productos capilares?"], o:YN},
    {k:"allergyWhat", t:"textarea", l:["If yes, which product and what happened?","Si respondió sí, ¿qué producto y qué ocurrió?"]},
    {k:"safetyOther", t:"textarea", l:["Anything else your stylist should know before working with chemicals?","¿Algo más que su estilista deba saber antes de trabajar con químicos?"]}
  ]
},
{
  n:["Your routine at home","Su rutina en casa"],
  note:["All optional. Answer what you know.","Todo opcional. Responda lo que sepa."],
  fields:[
    {k:"washes", t:"radio", l:["How often do you wash your hair?","¿Con qué frecuencia lava su cabello?"], o:[
      ["Every day","Todos los días"],["4 to 6 times a week","4 a 6 veces por semana"],["2 to 3 times a week","2 a 3 veces por semana"],
      ["Once a week","Una vez por semana"],["Less than once a week","Menos de una vez por semana"]]},
    {k:"shampoo", t:"text", l:["Which shampoo do you use?","¿Qué shampoo utiliza?"]},
    {k:"conditioner", t:"text", l:["Conditioner or mask?","¿Acondicionador o mascarilla?"]},
    {k:"purple", t:"radio", inline:true, l:["Do you use purple shampoo?","¿Usa shampoo morado?"], o:YN},
    {k:"depositing", t:"radio", inline:true, l:["Any oils, pigmented masks, or color-depositing products?","¿Aceites, mascarillas con pigmento o productos que depositan color?"], o:YN},
    {k:"depositingWhat", t:"text", l:["If yes, which ones?","Si respondió sí, ¿cuáles?"]},
    {k:"heat", t:"radio", l:["How often do you use hot tools?","¿Con qué frecuencia usa herramientas calientes?"], o:[
      ["Every day","Todos los días"],["Several times a week","Varias veces por semana"],["Once a week","Una vez por semana"],
      ["Occasionally","Ocasionalmente"],["Never","Nunca"]]},
    {k:"protectant", t:"radio", inline:true, l:["Do you use heat protectant?","¿Usa protector térmico?"], o:[["Always","Siempre"],["Sometimes","A veces"],["Never","Nunca"]]}
  ]
},
{
  n:["Upkeep","Mantenimiento"],
  fields:[
    {k:"maintenance", t:"radio", req:true, l:["How often could you realistically come back for maintenance?","¿Con qué frecuencia podría regresar realmente para mantenimiento?"], o:[
      ["Every 6 to 8 weeks","Cada 6 a 8 semanas"],["Every 8 to 12 weeks","Cada 8 a 12 semanas"],
      ["Every 3 to 4 months","Cada 3 a 4 meses"],["Once or twice a year","1 o 2 veces al año"],
      ["As little as possible","Lo mínimo posible"],["Not sure yet","Aún no estoy segura"]]}
  ]
},
{
  n:["Photos of your hair","Fotos de su cabello"],
  note:["Two photos, no filter, in daylight if you can. Clear photos are what let your stylist plan properly before you arrive.",
        "Dos fotos, sin filtro, con luz natural si es posible. Las fotos nítidas son lo que permite a su estilista planificar antes de su cita."],
  fields:[
    {k:"photoFront", t:"files", req:true, max:2, l:["Front, hair down","Frente, cabello suelto"],
      hint:["Show your roots and hairline.","Muestre su raíz y contorno."]},
    {k:"photoBack", t:"files", req:true, max:3, l:["Back, hair opened up","Parte posterior, cabello abierto"],
      hint:["Please separate the hair in the back so the inside layers, the root area, and the hair underneath are visible. Don't photograph only the outer surface.",
            "Por favor separe el cabello en la parte de atrás para que se vean las capas interiores, la zona de la raíz y el cabello de abajo. No fotografíe solo la superficie exterior."]}
  ]
},
{
  n:["Inspiration","Inspiración"],
  fields:[
    {k:"photoInspo", t:"files", req:true, max:4, l:["Upload 2 to 4 photos of the result you'd love","Suba 2 a 4 fotos del resultado que le encantaría"]}
  ]
},
{
  n:["Anything else","Algo más"],
  fields:[
    {k:"anythingElse", t:"textarea", l:["Anything we didn't ask that you'd want your stylist to know?","¿Algo que no le preguntamos y que quisiera que su estilista sepa?"]}
  ]
}
];

/* ---------- Consent copy. Edit the wording here. ---------- */

const CONSENT_BLOCKS = [
{ h:["What you're agreeing to","Lo que está aceptando"],
  p:["You've voluntarily requested a consultation and/or a service involving Grey Blending, color correction, lightening, bleaching, coloring, toning, or another chemical process. The final result depends on many factors, and a result identical to an inspiration photograph can't be guaranteed.",
     "Usted ha solicitado voluntariamente una consulta y/o un servicio de Grey Blending, corrección de color, aclaración, decoloración, coloración, tonalización u otro proceso químico. El resultado final depende de muchos factores y no puede garantizarse un resultado idéntico a una fotografía de inspiración."]},
{ h:["What affects the result","Qué afecta el resultado"],
  p:["Your result is shaped by your previous coloring history and accumulated artificial pigment; permanent, demi-permanent or commercial dyes, henna, vegetable dyes or metallic salts; past bleaching, color corrections and chemical services; keratins, straightening, relaxers, perms, nanoplasty or protein treatments; your hair's porosity, elasticity, texture, density and current condition; how much natural gray you have and how differently each area resists; and medications, hormonal changes, minerals in your water, and other factors that change how hair behaves. Concealing, forgetting, or not knowing about a previous procedure can change how your hair reacts and raise the risk of an unexpected result.",
     "Su resultado depende del historial previo de coloración y los pigmentos artificiales acumulados; tintes permanentes, demi-permanentes o comerciales, henna, tintes vegetales o sales metálicas; decoloraciones, correcciones de color y servicios químicos previos; keratinas, alisados, relajantes, permanentes, nanoplastias o tratamientos de proteínas; la porosidad, elasticidad, textura, densidad y condición actual de su cabello; la cantidad de cana natural y la resistencia distinta de cada área; y medicamentos, cambios hormonales, minerales en el agua y otros factores que cambian el comportamiento del cabello. Ocultar, olvidar o desconocer un procedimiento anterior puede cambiar la reacción de su cabello y aumentar el riesgo de un resultado inesperado."]},
{ h:["Possible reactions and risks","Posibles reacciones y riesgos"],
  p:["Even with professional technique, appropriate products and reasonable precautions, any chemical procedure can produce results that aren't fully predictable: dryness, increased porosity or texture changes; fragility, loss of elasticity, breakage or weakened ends; the need to cut compromised hair; uneven lightening or temporary yellow, orange or red tones; color differences caused by accumulated artificial pigment; the need for several sessions, or the impossibility of safely reaching a certain tone; scalp sensitivity or irritation; and unexpected reactions between current products and chemicals used before. A strand test shows how one section responds, but doesn't guarantee every area will react the same way.",
     "Incluso con técnica profesional, productos apropiados y precauciones razonables, cualquier procedimiento químico puede producir resultados no completamente predecibles: resequedad, mayor porosidad o cambios de textura; fragilidad, pérdida de elasticidad, rotura o puntas debilitadas; necesidad de cortar cabello comprometido; aclaración desigual o tonos temporales amarillos, anaranjados o rojizos; diferencias de color por pigmentos artificiales acumulados; necesidad de varias sesiones o imposibilidad de alcanzar cierto tono de forma segura; sensibilidad o irritación del cuero cabelludo; y reacciones inesperadas entre productos actuales y químicos usados antes. Una prueba de mecha muestra cómo responde una sección, pero no garantiza que todas las áreas reaccionen igual."]},
{ h:["Your hair's integrity comes first","La integridad de su cabello es lo primero"],
  p:["Your stylist's priority is preserving the integrity of your hair as far as reasonably possible. That means they may change the technique, reduce the level of lightening, or stop the procedure if continuing would compromise your hair too much. They may recommend repair treatments, cutting compromised areas, or splitting the work across several sessions — which can mean the result you wanted isn't reached in a single appointment. Situations that weren't visible before starting can also appear mid-service, and the service may be modified or stopped if the risk rises significantly.",
     "La prioridad de su estilista es preservar la integridad de su cabello dentro de lo razonablemente posible. Eso significa que puede cambiar la técnica, reducir el nivel de aclaración o detener el procedimiento si continuar comprometería demasiado su cabello. Puede recomendar tratamientos reparadores, cortar áreas comprometidas o dividir el trabajo en varias sesiones, lo que puede significar que el resultado deseado no se alcance en una sola cita. También pueden aparecer situaciones no visibles antes de comenzar, y el servicio puede modificarse o detenerse si el riesgo aumenta significativamente."]},
{ h:["Expectations and upkeep","Expectativas y mantenimiento"],
  p:["Grey Blending doesn't necessarily mean removing all artificial color or turning your hair fully gray, silver or white right away. It may take one or several sessions, plus toning, treatments and professional maintenance. Inspiration photographs are visual references only, and every head of hair responds differently. Excessive heat, products that weren't recommended, at-home color, work done elsewhere, pools, minerals and environmental exposure can all change your result or increase fragility.",
     "Grey Blending no significa necesariamente eliminar todo el color artificial ni volver su cabello completamente gris, plata o blanco de inmediato. Puede requerir una o varias sesiones, además de tonalizaciones, tratamientos y mantenimiento profesional. Las fotografías de inspiración son solo referencias visuales y cada cabello responde de forma distinta. El calor excesivo, productos no recomendados, color aplicado en casa, trabajos hechos en otro lugar, piscinas, minerales y la exposición ambiental pueden cambiar su resultado o aumentar la fragilidad."]},
{ h:["Our right to decline or stop a service","Nuestro derecho a rechazar o detener un servicio"],
  p:["Grey Hair Salon and/or the performing hairstylist reserves the right, at their professional discretion, to decline, discontinue, modify, or cancel a service at any point before or during the appointment when circumstances arise that make proceeding inappropriate, unsafe, or otherwise inadvisable. This may include, but is not limited to, concerns regarding the condition or integrity of the hair, the client's ability or willingness to follow professional recommendations, conduct or behavior, safety concerns, or any other circumstance that, in the professional judgment of the salon or hairstylist, prevents the service from being performed appropriately. When a service is canceled or discontinued under these circumstances, the appointment deposit may be retained and considered non-refundable.",
     "Grey Hair Salon y/o el estilista que realiza el servicio se reserva el derecho, a su criterio profesional, de rechazar, discontinuar, modificar o cancelar un servicio en cualquier momento antes o durante la cita cuando surjan circunstancias que hagan que continuar sea inapropiado, inseguro o de otro modo desaconsejable. Esto puede incluir, entre otros, preocupaciones sobre la condición o integridad del cabello, la capacidad o disposición de la clienta para seguir las recomendaciones profesionales, la conducta o el comportamiento, preocupaciones de seguridad, o cualquier otra circunstancia que, a juicio profesional del salón o del estilista, impida que el servicio se realice adecuadamente. Cuando un servicio sea cancelado o discontinuado bajo estas circunstancias, el depósito de la cita podrá ser retenido y considerado no reembolsable."]}
];

const ACKS = [
  ["I've read and understood everything above, including the factors, risks and limitations.",
   "He leído y comprendido todo lo anterior, incluidos los factores, riesgos y limitaciones."],
  ["What I've told you about my hair's chemical history is true and complete as far as I know.",
   "Lo que les he contado sobre el historial químico de mi cabello es verdadero y completo según mi conocimiento."],
  ["I understand the result can't be guaranteed, that more than one session may be needed, and that a result identical to an inspiration photo can't be promised.",
   "Entiendo que el resultado no puede garantizarse, que puede necesitarse más de una sesión, y que no puede prometerse un resultado idéntico a una foto de inspiración."],
  ["I understand and authorize my stylist to modify, pause or stop the service at their professional discretion, and I acknowledge the salon's right to decline or discontinue service as described above, in which case my deposit may be kept and is non-refundable.",
   "Entiendo y autorizo a mi estilista a modificar, pausar o detener el servicio a su criterio profesional, y reconozco el derecho del salón a rechazar o discontinuar el servicio según lo descrito, en cuyo caso mi depósito podrá retenerse y no es reembolsable."],
  ["I agree to go ahead with the service based on my stylist's professional judgment, and I accept the aftercare and maintenance recommendations.",
   "Acepto proceder con el servicio según el criterio profesional de mi estilista, y acepto las recomendaciones de cuidado posterior y mantenimiento."]
];

const MEDIA_OPTS = [
  ["Yes — you may photograph and film me, including my face, and publish it.",
   "Sí — pueden fotografiarme y filmarme, incluyendo mi rostro, y publicarlo."],
  ["Only my hair — as long as my face isn't identifiable.",
   "Solo mi cabello — siempre que mi rostro no sea identificable."],
  ["No — please don't publish anything I could be identified in.",
   "No — por favor no publiquen nada donde pueda ser identificada."]
];

/* ---------- Photos the stylist takes during the consultation ---------- */

const TECH_PHOTOS = [
  { k:"tpFront",  l:"Front, hair down · Frente, cabello suelto",
    hint:"Same angle the client sent — roots and hairline visible. · Mismo ángulo que envió la clienta — raíz y contorno visibles.", max:2 },
  { k:"tpBack",   l:"Back, hair opened up · Parte posterior, cabello abierto",
    hint:"Separate the hair so the interior layers and underneath show. · Separe el cabello para que se vean las capas interiores y la parte de abajo.", max:3 },
  { k:"tpGrowth", l:"Close-up above the growth line · Primer plano sobre la línea de crecimiento",
    hint:"Tight shot just above where the natural regrowth ends. · Toma cerrada justo encima de donde termina el crecimiento natural.", max:3 },
  { k:"tpStrand", l:"Strand test result · Resultado de la prueba de mecha",
    hint:"After the test — show the level achieved against the rest. · Después de la prueba — muestre el nivel alcanzado contra el resto.", max:4 }
];

/* ---------- Internal technical record. Stylist only. ---------- */

const TECH_CONSULT = [
{ n:"Hair analysis · Análisis del cabello", fields:[
  {k:"pctGray",   t:"text", l:"Actual % of gray · % real de cana"},
  {k:"grayDist",  t:"text", l:"Gray pattern / distribution · Patrón / distribución de cana"},
  {k:"natLevel",  t:"text", l:"Natural level · Nivel natural"},
  {k:"cosLevel",  t:"text", l:"Existing cosmetic level · Nivel cosmético existente"},
  {k:"porosity",  t:"text", l:"Porosity · Porosidad"},
  {k:"elasticity",t:"text", l:"Elasticity · Elasticidad"},
  {k:"density",   t:"text", l:"Density · Densidad"},
  {k:"texture",   t:"text", l:"Texture · Textura"},
  {k:"integrity", t:"text", l:"Overall integrity · Integridad general"},
  {k:"resistance",t:"text", l:"Hair resistance · Resistencia del cabello"},
  {k:"chemHist",  t:"textarea", l:"Relevant chemical history · Historial químico relevante"}
]},
{ n:"Strand test · Prueba de mecha", fields:[
  {k:"strandResult", t:"textarea", l:"Strand test result · Resultado de la prueba"},
  {k:"levelAchieved",t:"text", l:"Level achieved in test · Nivel alcanzado en la prueba"},
  {k:"underlying",   t:"text", l:"Underlying pigment · Fondo de aclaración"},
  {k:"candidate",    t:"radio", req:true, inline:true, l:"Candidate? · ¿Candidata?",
    o:["Yes / Sí","No","With conditions / Con condiciones"]},
  {k:"candidateNote",t:"textarea", l:"If no or conditional, explain · Si es no o condicional, explique"}
]}
];

const TECH_PLAN = [
{ n:"Proposed plan · Plan propuesto", fields:[
  {k:"design",    t:"textarea", l:"Recommended design · Diseño recomendado"},
  {k:"technique", t:"textarea", l:"Proposed technique · Técnica propuesta"},
  {k:"lightZones",t:"text", l:"Lightness / light zones · Claridad / zonas claras"},
  {k:"lowlights", t:"text", l:"Darkness / lowlights · Oscuridad / lowlights"},
  {k:"hairline",  t:"text", l:"Hairline / money piece · Contorno / money piece"},
  {k:"formula",   t:"textarea", l:"Proposed formula · Fórmula propuesta"},
  {k:"pretreat",  t:"textarea", l:"Recommended pre-treatment · Tratamiento previo recomendado"},
  {k:"sessions",  t:"text", l:"Estimated number of sessions · Número estimado de sesiones"},
  {k:"maintFreq", t:"text", l:"Maintenance frequency · Frecuencia de mantenimiento"}
]},
{ n:"Notes · Observaciones", fields:[
  {k:"observations", t:"textarea", l:"Stylist observations · Observaciones del estilista"},
  {k:"nextPlan",     t:"textarea", l:"Plan for next appointment · Plan para la próxima cita"}
]}
];

const RECORDS = {
  consult: { key:"consultations", draft:"consultDraft", sections:TECH_CONSULT, photos:true,
             title:"Consultations · Consultas",
             note:"Hair analysis and strand test. Save progress while you work; submit when it's final.",
             one:"consultation · consulta", req:"candidate",
             reqMsg:"Set Candidate? before submitting. · Marque ¿Candidata? antes de enviar." },
  plan:    { key:"plans", draft:"planDraft", sections:TECH_PLAN, photos:false,
             title:"Proposed plans · Planes propuestos",
             note:"Whoever is performing the service fills this in. It can be a different stylist, on a different day.",
             one:"plan", req:null }
};


/* ---------- What the stylist logs after each appointment ---------- */

const VISIT_FIELDS = [
  {k:"formula",   t:"textarea", l:"Formula used · Fórmula utilizada",
    hint:"Everything — lightener, developer, toner, timing. · Todo: decolorante, revelador, tonalizador, tiempos."},
  {k:"technique", t:"textarea", l:"Technique and pattern · Técnica y patrón",
    hint:"How it was sectioned and placed. · Cómo se seccionó y colocó."},
  {k:"whatDone",  t:"textarea", l:"What was done · Qué se realizó"},
  {k:"result",    t:"text",     l:"Level / result achieved · Nivel o resultado alcanzado"},
  {k:"styling",   t:"text",     l:"Cut or styling · Corte o peinado"},
  {k:"homeCare",  t:"textarea", l:"Home care recommended · Cuidado en casa recomendado",
    hint:"Shampoo, conditioner, masks, heat, wash frequency. · Shampoo, acondicionador, mascarillas, calor, frecuencia de lavado."},
  {k:"issues",    t:"textarea", l:"Anything that came up · Algo que surgió"},
  {k:"nextService",t:"text",    l:"Next appointment — what service · Próxima cita — qué servicio"},
  {k:"nextWhen",  t:"text",     l:"Next appointment — when · Próxima cita — cuándo",
    hint:"Booked, or the window you recommended. · Agendada, o el plazo que recomendó."}
];

const VISIT_PHOTOS = [
  { k:"vpBefore", l:"Before · Antes",  max:3 },
  { k:"vpAfter",  l:"After · Después", max:4 }
];

/* ============================================================
   APP — you shouldn't need to edit below this line.
   ============================================================ */

import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.5/firebase-app.js";
import { getFirestore, collection, addDoc, setDoc, getDocs, doc, getDoc, updateDoc, query, orderBy, serverTimestamp }
  from "https://www.gstatic.com/firebasejs/10.12.5/firebase-firestore.js";
import { getStorage, ref as sref, uploadBytes, getDownloadURL }
  from "https://www.gstatic.com/firebasejs/10.12.5/firebase-storage.js";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged, setPersistence, inMemoryPersistence }
  from "https://www.gstatic.com/firebasejs/10.12.5/firebase-auth.js";

const fb = initializeApp(CONFIG.firebase);
const db = getFirestore(fb);
const store = getStorage(fb);
const auth = getAuth(fb);
// Sessions never survive a refresh or a closed tab. On a shared salon iPad
// that means walking away and reloading is enough to lock it.
setPersistence(auth, inMemoryPersistence);

// The app authenticates itself so Firebase will hand over data at all.
// Staff never see this — they only ever type a PIN.
let appReady = null;
function connect(){
  if (!appReady) appReady = signInWithEmailAndPassword(
    auth, CONFIG.appAccount.email, CONFIG.appAccount.password);
  return appReady;
}

let app, railEl, VIEW;
function mount(){
  app    = document.getElementById("ghs-app");
  railEl = document.getElementById("ghs-rail-i");
  VIEW   = app && app.dataset.view === "staff" ? "staff" : "client";
  return !!app;
}
const S = { lang: (navigator.language||"en").startsWith("es") ? 1 : 0, step: 0, a: {}, files: {}, sig: null, me: null };

const T  = p => Array.isArray(p) ? (p[S.lang] ?? p[0]) : p;
const esc = s => String(s??"").replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const $  = (s,r=document) => r.querySelector(s);
const $$ = (s,r=document) => [...r.querySelectorAll(s)];
const L  = (en,es) => S.lang ? es : en;

const canSeeContacts = () => !!(S.me && S.me.contacts);

function maskPhone(v){
  const digits = String(v || "").replace(/\D/g, "");
  if (!digits) return "";
  if (canSeeContacts()) return v;
  return digits.length >= 4 ? "•••• " + digits.slice(-4) : "••••";
}
function maskEmail(v){
  if (!v) return "";
  return canSeeContacts() ? v : "hidden · oculto";
}

function toast(msg){
  const d = document.createElement("div");
  d.className = "toast"; d.textContent = msg; document.body.appendChild(d);
  setTimeout(()=>d.remove(), 3200);
}
function rail(pct){ if(!railEl) return; railEl.style[window.innerWidth<=640?"width":"height"] = pct + "%"; }

/* ---------- entry ---------- */
let STAFF_MODE = "salon";           // "salon" (floor) or "admin" (profiles)
function route(){
  if (!mount()) return;
  rail(0);
  const eid = new URLSearchParams(location.search).get("e");
  if (eid && VIEW !== "staff") return estimateView(eid);
  // On the estimate page with no link code: say so, don't show the intake form.
  if (VIEW !== "staff" && onEstimatePage()) return estimateMissing();
  if (VIEW === "staff") staffView(STAFF_MODE);
  else intakeView();
}

/* ============================================================
   CLIENT INTAKE
   ============================================================ */

const TOTAL = INTAKE.length + 2; // + media release, + consent

function intakeView(){
  app.innerHTML = `
    <div class="ghs-wrap">
      <header class="mast">
        <div class="salon">${esc(CONFIG.salonName.toUpperCase())}</div>
        <h1 class="mark">Grey<br><em>Blending.</em></h1>
        <div class="langs">
          <button data-l="0" aria-pressed="${S.lang===0}">English</button>
          <button data-l="1" aria-pressed="${S.lang===1}">Español</button>
        </div>
      </header>
      <div id="body"></div>
    </div>`;
  $$(".langs button").forEach(b => b.onclick = () => { S.lang = +b.dataset.l; intakeView(); });
  S.step = S.step || 0;
  drawStep();
}

function drawStep(){
  const b = $("#body");
  rail(Math.round(S.step / TOTAL * 100));
  window.scrollTo({top:0, behavior:"instant"});

  if (S.step === 0 && !S.started){
    b.innerHTML = `
      <div class="intro">
        <p>${L("Please fill this out before your appointment. It takes about ten minutes, and most of it is optional.",
              "Por favor complete esto antes de su cita. Toma unos diez minutos y la mayoría es opcional.")}</p>
        <p>${L("What you tell us here lets your stylist understand your history and your goals before you sit in the chair.",
              "Lo que nos cuente aquí permite a su estilista conocer su historial y sus objetivos antes de que se siente en la silla.")}</p>
        <p><strong>${L("This form doesn't guarantee you're a candidate for Grey Blending, or that the service can happen the same day. The final diagnosis is made in person and may include a strand test.",
              "Este formulario no garantiza que sea candidata para Grey Blending ni que el servicio pueda realizarse el mismo día. El diagnóstico definitivo se realiza en persona y puede incluir una prueba de mecha.")}</strong></p>
      </div>
      <div class="nav"><button class="btn" id="go">${L("Start","Comenzar")}</button></div>`;
    $("#go").onclick = () => { S.started = true; drawStep(); };
    return;
  }

  let html = "";
  if (S.step < INTAKE.length){
    const sec = INTAKE[S.step];
    html = `<div class="step on">
      <div class="stepnum">${L("SECTION","SECCIÓN")} ${S.step+1} / ${TOTAL}</div>
      <h2 class="steptitle">${esc(T(sec.n))}</h2>
      ${sec.note ? `<p class="stepnote">${esc(T(sec.note))}</p>` : ""}
      ${sec.fields.map(fieldHTML).join("")}
    </div>`;
  } else if (S.step === INTAKE.length){
    html = mediaHTML();
  } else {
    html = consentHTML();
  }

  const last = S.step === TOTAL - 1;
  b.innerHTML = html + `
    <div class="nav">
      ${S.step>0 ? `<button class="btn ghost" id="back">${L("Back","Atrás")}</button>` : ""}
      <button class="btn" id="next">${last ? L("Submit","Enviar") : L("Continue","Continuar")}</button>
      <span class="count">${S.step+1} / ${TOTAL}</span>
    </div>
    <div class="err" id="err" hidden></div>`;

  bindFields();
  if ($("#back")) $("#back").onclick = () => { S.step--; drawStep(); };
  $("#next").onclick = () => last ? submit() : advance();
}

function fieldHTML(f){
  const id = "f_" + f.k;
  const req = f.req ? "" : `<span class="opt">${L("optional","opcional")}</span>`;
  const label = `${esc(T(f.l))}${req}`;
  const hint = f.hint ? `<span class="hint">${esc(T(f.hint))}</span>` : "";
  const v = S.a[f.k];

  if (f.t === "text" || f.t === "tel" || f.t === "email" || f.t === "date"){
    return `<div class="f"><label for="${id}">${label}</label>${hint}
      <input type="${f.t}" id="${id}" data-k="${f.k}" value="${esc(v||"")}"></div>`;
  }
  if (f.t === "textarea"){
    return `<div class="f"><label for="${id}">${label}</label>${hint}
      <textarea id="${id}" data-k="${f.k}">${esc(v||"")}</textarea></div>`;
  }
  if (f.t === "radio" || f.t === "checks"){
    const multi = f.t === "checks";
    const cur = multi ? (v||[]) : v;
    const opts = f.o.map((o,i) => {
      const val = o[0], lab = T(o);
      const on = multi ? cur.includes(val) : cur === val;
      return `<label class="ch"><input type="${multi?"checkbox":"radio"}" name="${id}" data-k="${f.k}"
        data-multi="${multi}" value="${esc(val)}" ${on?"checked":""}><span>${esc(lab)}</span></label>`;
    }).join("");
    return `<div class="f"><span class="q">${label}</span>${hint}
      <div class="choices ${f.inline?"inline":""}">${opts}</div></div>`;
  }
  if (f.t === "files"){
    const n = (S.files[f.k]||[]).length;
    return `<div class="f"><span class="q">${label}</span>${hint}
      <div class="drop">
        <p>${L("JPG or PNG. Up to","JPG o PNG. Hasta")} ${f.max} ${L("photos.","fotos.")}</p>
        <input type="file" accept="image/*" multiple data-file="${f.k}" data-max="${f.max}">
        <div class="thumbs" id="th_${f.k}">${n?`${n} ${L("selected","seleccionadas")}`:""}</div>
      </div></div>`;
  }
  return "";
}

function mediaHTML(){
  const v = S.a.mediaRelease;
  return `<div class="step on">
    <div class="stepnum">${L("SECTION","SECCIÓN")} ${S.step+1} / ${TOTAL}</div>
    <h2 class="steptitle">${L("Photos and video","Fotos y video")}</h2>
    <p class="stepnote">${L("This one is entirely up to you. Saying no changes nothing about your consultation or your service.",
      "Esto depende completamente de usted. Decir que no no cambia nada de su consulta ni de su servicio.")}</p>
    <div class="legal"><p>${L(
      "During your consultation and service we may photograph or film your hair and the process, for our portfolio, education, promotion and social media. This can include before, during and after images, and depending on the content your face may appear. We don't pay for authorized use unless we agree otherwise in writing, and material may be edited or cropped, always in relation to the professional work performed.",
      "Durante su consulta y servicio podemos fotografiar o filmar su cabello y el proceso, para nuestro portafolio, educación, promoción y redes sociales. Esto puede incluir imágenes de antes, durante y después, y según el contenido su rostro podría aparecer. No pagamos por el uso autorizado salvo acuerdo escrito distinto, y el material puede editarse o recortarse, siempre en relación al trabajo profesional realizado.")}</p></div>
    <div class="f"><span class="q">${L("Choose one","Elija una")}</span>
      <div class="choices">${MEDIA_OPTS.map(o=>`
        <label class="ch"><input type="radio" name="mr" data-k="mediaRelease" data-multi="false"
          value="${esc(o[0])}" ${v===o[0]?"checked":""}><span>${esc(T(o))}</span></label>`).join("")}
      </div></div>
  </div>`;
}

function consentHTML(){
  const acks = S.a.acks || [];
  return `<div class="step on">
    <div class="stepnum">${L("SECTION","SECCIÓN")} ${S.step+1} / ${TOTAL}</div>
    <h2 class="steptitle">${L("Consent","Consentimiento")}</h2>
    <p class="stepnote">${L("Please read this before signing.","Por favor lea esto antes de firmar.")}</p>
    ${CONSENT_BLOCKS.map(b=>`<div class="legal"><h4>${esc(T(b.h))}</h4><p>${esc(T(b.p))}</p></div>`).join("")}
    <div class="f"><span class="q">${L("Please confirm each one","Por favor confirme cada uno")}</span>
      <div class="choices">${ACKS.map((a,i)=>`
        <label class="ch"><input type="checkbox" data-ack="${i}" ${acks.includes(i)?"checked":""}>
        <span>${esc(T(a))}</span></label>`).join("")}
      </div></div>
    <div class="f"><span class="q">${L("Sign here with your finger or mouse","Firme aquí con su dedo o mouse")}</span>
      <div class="sigbox">
        <canvas id="sig"></canvas>
        <div class="sigbar"><span>${L("Draw your signature above","Dibuje su firma arriba")}</span>
        <button type="button" id="sigclr">${L("Clear","Borrar")}</button></div>
      </div></div>
    <div class="f"><label for="f_signName">${L("Type your full legal name","Escriba su nombre legal completo")}</label>
      <input type="text" id="f_signName" data-k="signName" value="${esc(S.a.signName||"")}"></div>
  </div>`;
}

/* ---------- binding ---------- */
function bindFields(){
  $$("input[data-k], textarea[data-k]").forEach(el => {
    if (el.type === "radio" || el.type === "checkbox"){
      el.onchange = () => {
        const k = el.dataset.k;
        if (el.dataset.multi === "true"){
          const set = new Set(S.a[k] || []);
          el.checked ? set.add(el.value) : set.delete(el.value);
          S.a[k] = [...set];
        } else S.a[k] = el.value;
      };
    } else {
      el.oninput = () => S.a[el.dataset.k] = el.value;
    }
  });
  $$("input[data-ack]").forEach(el => el.onchange = () => {
    const set = new Set(S.a.acks || []); const i = +el.dataset.ack;
    el.checked ? set.add(i) : set.delete(i);
    S.a.acks = [...set];
  });
  $$("input[data-file]").forEach(el => el.onchange = () => {
    const k = el.dataset.file, max = +el.dataset.max;
    let fs = [...el.files].filter(f => f.type.startsWith("image/"));
    if (fs.length > max){ fs = fs.slice(0,max); toast(L(`Only the first ${max} were kept.`, `Solo se guardaron las primeras ${max}.`)); }
    S.files[k] = fs;
    const box = $("#th_"+k); box.innerHTML = "";
    fs.forEach(f => { const i = new Image(); i.src = URL.createObjectURL(f); box.appendChild(i); });
  });
  if ($("#sig")) initSig();
}

function initSig(){
  const c = $("#sig"), ctx = c.getContext("2d");
  const dpr = window.devicePixelRatio || 1;
  const fit = () => {
    const r = c.getBoundingClientRect();
    c.width = r.width*dpr; c.height = r.height*dpr;
    ctx.scale(dpr,dpr); ctx.lineWidth = 1.8; ctx.lineCap = "round";
    ctx.lineJoin = "round"; ctx.strokeStyle = "#2B2A2E";
  };
  fit();
  let drawing = false;
  const pos = e => { const r = c.getBoundingClientRect(); const p = e.touches?e.touches[0]:e;
    return [p.clientX-r.left, p.clientY-r.top]; };
  const start = e => { e.preventDefault(); drawing = true; ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move  = e => { if(!drawing) return; e.preventDefault(); ctx.lineTo(...pos(e)); ctx.stroke(); S.sig = c.toDataURL("image/png"); };
  const end   = () => drawing = false;
  c.addEventListener("pointerdown", start); c.addEventListener("pointermove", move);
  window.addEventListener("pointerup", end);
  $("#sigclr").onclick = () => { ctx.clearRect(0,0,c.width,c.height); S.sig = null; };
}

/* ---------- validation ---------- */
function advance(){
  const miss = validate();
  if (miss){ showErr(miss); return; }
  S.step++; drawStep();
}
function showErr(m){ const e = $("#err"); e.hidden = false; e.textContent = m; e.scrollIntoView({block:"center"}); }

function validate(){
  if (S.step < INTAKE.length){
    for (const f of INTAKE[S.step].fields){
      if (!f.req) continue;
      if (f.t === "files"){
        if (!(S.files[f.k]||[]).length) return L("Please add "+T(f.l).toLowerCase()+".", "Por favor agregue: "+T(f.l).toLowerCase()+".");
      } else if (f.t === "checks"){
        if (!(S.a[f.k]||[]).length) return L("Please answer: ","Por favor responda: ") + T(f.l);
      } else if (!S.a[f.k] || !String(S.a[f.k]).trim()){
        return L("Please answer: ","Por favor responda: ") + T(f.l);
      }
    }
  } else if (S.step === INTAKE.length){
    if (!S.a.mediaRelease) return L("Please choose one option.","Por favor elija una opción.");
  } else {
    if ((S.a.acks||[]).length !== ACKS.length)
      return L("Please confirm all five statements.","Por favor confirme las cinco declaraciones.");
    if (!S.sig) return L("Please sign in the box.","Por favor firme en el recuadro.");
    if (!(S.a.signName||"").trim()) return L("Please type your full legal name.","Por favor escriba su nombre legal completo.");
  }
  return null;
}

/* ---------- submit ---------- */
async function submit(){
  const miss = validate(); if (miss) return showErr(miss);
  const btn = $("#next"); btn.disabled = true;
  btn.textContent = L("Sending…","Enviando…");
  try {
    // Reserve an ID without writing. The client may only CREATE, never update,
    // so everything has to go in one single write at the end.
    const ref = doc(collection(db, "clients"));

    const photos = {};
    for (const k of Object.keys(S.files)){
      photos[k] = [];
      for (const [i,file] of S.files[k].entries()){
        const p = sref(store, `clients/${ref.id}/${k}_${i}.jpg`);
        await uploadBytes(p, file);
        photos[k].push(p.fullPath);   // path only — staff resolve the link when signed in
      }
      btn.textContent = L("Uploading photos…","Subiendo fotos…");
    }

    let sigPath = null;
    if (S.sig){
      const blob = await (await fetch(S.sig)).blob();
      const p = sref(store, `clients/${ref.id}/signature.png`);
      await uploadBytes(p, blob);
      sigPath = p.fullPath;
    }

    btn.textContent = L("Sending…","Enviando…");
    await setDoc(ref, {
      answers: S.a, lang: S.lang ? "es" : "en",
      status: "new", claimedBy: null, technical: null,
      photos, signature: sigPath,
      createdAt: serverTimestamp(),
      signedAt: serverTimestamp(),
      name: S.a.name || "", phone: S.a.phone || ""
    });
    done();
  } catch(e){
    console.error(e);
    btn.disabled = false; btn.textContent = L("Submit","Enviar");
    showErr(L("That didn't send. Check your connection and try again.",
              "No se pudo enviar. Revise su conexión e inténtelo de nuevo."));
  }
}

function done(){
  rail(100);
  $("#body").innerHTML = `<div class="done">
    <h2>${L("All set.","Listo.")}</h2>
    <p>${L("Your stylist will go through everything before your appointment. If anything needs clarifying, we'll reach out.",
          "Su estilista revisará todo antes de su cita. Si algo necesita aclararse, la contactaremos.")}</p>
  </div>`;
}

/* ============================================================
   STAFF — #/salon (stylists) and #/admin (owners)
   ============================================================ */

let CLIENTS = [];
let SHOW_ARCHIVED = false;
let FILTER = "";

function staffView(mode){
  if (!S.me){ gate(mode); return; }
  if (mode === "admin" && S.me.role !== "owner"){
    app.innerHTML = `<div class="ghs-wrap"><div class="gate"><h2>Owners only</h2>
      <p>${esc(S.me.name)} doesn't have access to client profiles.</p>
      <button class="btn ghost" id="backfloor">Back to the floor</button></div></div>`;
    $("#backfloor").onclick = () => { STAFF_MODE = "salon"; staffView("salon"); };
    return;
  }
  shell(mode);
  loadClients(mode);
}

function gate(mode){
  app.innerHTML = `<div class="ghs-wrap"><div class="gate">
    <h2>${esc(CONFIG.salonName)}</h2>
    <p class="stepnote" style="margin-bottom:1.25rem">Tap your name.</p>
    <div class="tiles" id="who"></div>
    <div id="pinwrap" hidden>
      <p class="stepnote" id="pinwho" style="margin:1.5rem 0 .75rem"></p>
      <div class="pindots" id="dots"></div>
      <div class="pinpad" id="pad"></div>
      <div class="err" id="gerr" hidden></div>
      <button class="btn ghost" id="pinback" style="margin-top:1rem">Someone else</button>
    </div>
  </div></div>`;

  const list = CONFIG.staff.filter(p => mode === "admin" ? p.role === "owner" : true);
  $("#who").innerHTML = list.map((p,i) =>
    `<button class="tile" data-i="${i}"><b>${esc(p.name)}</b><small>${esc(p.title || (p.role === "owner" ? "Owner" : "Hairstylist"))}</small></button>`).join("");

  let picked = null, pin = "", busy = false;
  const plen = () => (picked ? picked.pin.length : 4);
  const dots = () => $("#dots").innerHTML =
    Array.from({length:plen()}, (_,i) => `<i class="${i < pin.length ? "on" : ""}"></i>`).join("");

  $("#pad").innerHTML = [1,2,3,4,5,6,7,8,9,"",0,"del"].map(k =>
    k === "" ? `<span></span>` :
    `<button class="key" data-k="${k}">${k === "del" ? "←" : k}</button>`).join("");

  $$("#who .tile").forEach(t => t.onclick = () => {
    picked = list[+t.dataset.i];
    $("#who").hidden = true;
    $("#pinwrap").hidden = false;
    $("#pinwho").textContent = `Hi ${picked.name}. Enter your ${picked.pin.length}-digit PIN.`;
    pin = ""; dots();
  });

  $("#pinback").onclick = () => {
    picked = null; pin = ""; $("#who").hidden = false; $("#pinwrap").hidden = true; $("#gerr").hidden = true;
  };

  const submitPin = async () => {
    if (busy) return; busy = true;
    $("#gerr").hidden = true;
    if (pin !== picked.pin){
      pin = ""; dots();
      const g = $("#gerr"); g.hidden = false; g.textContent = "That PIN didn't work.";
      busy = false; return;
    }
    try {
      await connect();
      S.me = picked; startIdleLock(); staffView(mode);
    } catch(e){
      console.error(e);
      const g = $("#gerr"); g.hidden = false;
      g.textContent = "Can't reach the salon database. Check the connection.";
      pin = ""; dots();
    }
    busy = false;
  };

  const push = k => {
    if (k === "del"){ pin = pin.slice(0,-1); dots(); return; }
    if (pin.length >= plen()) return;
    pin += String(k); dots();
    if (pin.length === plen()) submitPin();
  };
  $$("#pad .key").forEach(b => b.onclick = () => push(b.dataset.k));
  document.addEventListener("keydown", e => {
    if (!picked || $("#pinwrap").hidden) return;
    if (/^[0-9]$/.test(e.key)) push(e.key);
    else if (e.key === "Backspace") push("del");
  });
  dots();
}

/* ---------- auto-lock on a shared device ---------- */
let idleTimer = null;
const IDLE_MS = 45 * 60 * 1000;
function startIdleLock(){
  const reset = () => {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(async () => {
      S.me = null;
      toast("Locked after 45 minutes idle. · Bloqueado por inactividad.");
      route();
    }, IDLE_MS);
  };
  ["pointerdown","keydown","scroll"].forEach(ev =>
    document.addEventListener(ev, reset, { passive: true }));
  reset();
}

function shell(mode){
  app.innerHTML = `
    <div class="staffbar">
      <b>${esc(S.me.name)}</b>
      <span style="font-size:.82rem;opacity:.7">${mode === "admin" ? "Client profiles" : "Consultation floor"}</span>
      <span class="sp">
        ${S.me.role === "owner" ? `<button id="swap">${mode === "admin" ? "Floor" : "Profiles"}</button>` : ""}
        ${S.me.role === "owner" ? `<button id="arch">${SHOW_ARCHIVED ? "Active" : "Archived"}</button>` : ""}
        <button id="refresh">Refresh</button>
        <button id="out">Sign out</button>
      </span>
    </div>
    <div class="ghs-wrap"><div id="staff"></div></div>`;
  if ($("#swap")) $("#swap").onclick = () => { STAFF_MODE = mode === "admin" ? "salon" : "admin"; staffView(STAFF_MODE); };
  if ($("#arch")) $("#arch").onclick = () => { SHOW_ARCHIVED = !SHOW_ARCHIVED; staffView(mode); };
  $("#refresh").onclick = () => loadClients(mode);
  $("#out").onclick = () => { clearTimeout(idleTimer); S.me = null; location.reload(); };
}

async function loadClients(mode){
  const el = $("#staff");
  el.innerHTML = `<div class="empty">Loading…</div>`;
  try {
    const snap = await getDocs(query(collection(db,"clients"), orderBy("createdAt","desc")));
    CLIENTS = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    listClients(mode);
  } catch(e){
    console.error(e);
    el.innerHTML = `<div class="empty">Couldn't load clients. Check your Firestore rules and try Refresh.</div>`;
  }
}

function when(ts){
  if (!ts?.toDate) return "";
  const d = ts.toDate(), now = new Date();
  const days = Math.floor((now - d) / 864e5);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return days + " days ago";
  return d.toLocaleDateString(undefined,{month:"short",day:"numeric"});
}

function newClientForm(mode){
  const el = $("#staff");
  el.innerHTML = `<div class="prof" style="max-width:32rem">
    <button class="btn ghost" id="nback" style="margin:1.25rem 0 .5rem">← Back</button>
    <h2 class="steptitle">Add a client · Agregar clienta</h2>
    <p class="stepnote">For anyone who didn't fill out the Grey Blending intake — regular services, walk-ins, existing clients. You can log visits for her right away. · Para quien no llenó el formulario de Grey Blending.</p>
    <div class="f"><label>First and last name · Nombre y apellidos</label><input type="text" id="nn"></div>
    <div class="f"><label>Phone / WhatsApp · Teléfono</label><input type="text" id="np"></div>
    <div class="f"><label>Email · Correo <span class="opt">optional</span></label><input type="text" id="ne"></div>
    <div class="nav"><button class="btn" id="nsave">Add her · Agregar</button>
      <span class="count" id="nmsg"></span></div>
  </div>`;
  $("#nback").onclick = () => listClients(mode);
  $("#nsave").onclick = async () => {
    const name = $("#nn").value.trim(), phone = $("#np").value.trim();
    if (!name){ $("#nmsg").textContent = "Name is required."; return; }
    $("#nsave").disabled = true; $("#nmsg").textContent = "Saving…";
    try {
      const ref = doc(collection(db,"clients"));
      await setDoc(ref, {
        answers: { name, phone, email: $("#ne").value.trim() },
        source: "staff", status: "claimed", claimedBy: S.me.name,
        technical: null, photos: {}, signature: null, visits: [],
        createdAt: serverTimestamp(), name, phone
      });
      toast("Added.");
      await loadClients(mode);
      openClient(ref.id, mode);
    } catch(e){
      console.error(e);
      $("#nmsg").textContent = "Didn't save. Try again.";
      $("#nsave").disabled = false;
    }
  };
}

function listClients(mode){
  const el = $("#staff");
  const mine = mode === "salon";
  const q = (FILTER || "").toLowerCase().trim();
  const rows = CLIENTS.filter(c => {
    if (SHOW_ARCHIVED) return c.status === "archived";
    if (c.status === "archived") return false;
    if (!q) return true;
    return (c.name || "").toLowerCase().includes(q) || (c.phone || "").includes(q);
  });
  if (!rows.length){
    el.innerHTML = (SHOW_ARCHIVED ? "" :
      `<button class="btn" id="newclient" style="margin-top:1.5rem">+ Add a client · Agregar clienta</button>`) +
      `<div class="empty">${SHOW_ARCHIVED
      ? "Nothing archived."
      : FILTER ? "Nobody matches that. · Nadie coincide."
      : "Nothing here yet. New consultations land here the moment a client submits her form."}</div>`;
    if ($("#newclient")) $("#newclient").onclick = () => newClientForm(mode);
    return;
  }
  const bar = `<div style="display:flex;gap:.6rem;align-items:center;margin-top:1.5rem;flex-wrap:wrap">
    <input type="text" id="cfilter" placeholder="Search by name or phone · Buscar" value="${esc(FILTER)}" style="flex:1 1 14rem">
    ${SHOW_ARCHIVED ? "" : `<button class="btn" id="newclient">+ Add a client · Agregar</button>`}
  </div>`;
  el.innerHTML = bar + `<div class="queue">${rows.map(c => {
    const tag = c.status === "new" ? `<span class="tag new">UNCLAIMED</span>`
      : c.status === "done" ? `<span class="tag done">COMPLETE</span>`
      : c.status === "archived" ? `<span class="tag claimed">ARCHIVED</span>`
      : `<span class="tag claimed">${esc(c.claimedBy||"CLAIMED")}</span>`;
    return `<button class="card" data-id="${c.id}">
      <span><span class="nm">${esc(c.name || "No name")}</span>
      <span class="meta"> · ${when(c.createdAt)}${c.answers?.city ? " · " + esc(c.answers.city) : ""}</span></span>
      ${tag}</button>`;
  }).join("")}</div>`;
  if ($("#newclient")) $("#newclient").onclick = () => newClientForm(mode);
  const fi = $("#cfilter");
  if (fi) fi.oninput = () => {
    FILTER = fi.value;
    const at = fi.selectionStart;
    listClients(mode);
    const f2 = $("#cfilter"); if (f2){ f2.focus(); f2.setSelectionRange(at, at); }
  };
  $$(".card").forEach(b => b.onclick = () => openClient(b.dataset.id, mode));
}

/* ---------- one client ---------- */
function openClient(id, mode){
  const c = CLIENTS.find(x => x.id === id);
  const el = $("#staff");
  const canClaim = c.status === "new";
  const isMine = c.claimedBy === S.me.name;
  el.innerHTML = `
    <div class="prof">
      <button class="btn ghost" id="back" style="margin:1.25rem 0 .5rem">← All clients</button>
      <h2 class="steptitle" style="margin-top:.5rem">${esc(c.name||"No name")}</h2>
      <p class="stepnote">${esc(maskPhone(c.phone))}${c.answers?.email?" · "+esc(maskEmail(c.answers.email)):""} · ${when(c.createdAt)}
        ${c.claimedBy?` · <span class="pill">${esc(c.claimedBy)}</span>`:""}</p>
      ${canSeeContacts() ? "" : `<p class="stepnote" style="margin-top:-.5rem;font-size:.9rem">Contact details are limited to salon owners. · Los datos de contacto están limitados a las dueñas.</p>`}
      ${canClaim ? `<button class="btn" id="claim">Take this consultation · Tomar esta consulta</button>` : ""}
      ${(!canClaim && c.status !== "archived" && !isMine && c.claimedBy)
        ? `<button class="btn ghost" id="reassign">Reassign to me · Asignarme</button>` : ""}
      ${S.me.role === "owner" ? `<button class="btn ghost" id="arcbtn" style="margin-left:.5rem">${
        c.status === "archived" ? "Restore to the floor" : "Archive"}</button>` : ""}
      ${c.source === "staff"
        ? `<p class="stepnote">Added by ${esc(c.claimedBy || "staff")} — no Grey Blending intake on file. · Sin formulario de Grey Blending.</p>`
        : intakeReport(c)}
      ${c.technical ? legacyTech(c) : ""}
      ${c.source !== "staff" ? recordBlock(c, "consult") : ""}
      ${c.source !== "staff" ? recordBlock(c, "plan") : ""}
      ${S.me.role === "owner" ? estimatesBlock(c) : ""}
      ${visitsBlock(c)}
    </div>`;
  $("#back").onclick = () => listClients(mode);
  hydratePhotos();
  if ($("#claim")) $("#claim").onclick = async () => {
    await updateDoc(doc(db,"clients",c.id), { status:"claimed", claimedBy:S.me.name });
    c.status = "claimed"; c.claimedBy = S.me.name; toast("She's yours."); openClient(id, mode);
  };
  if ($("#reassign")) $("#reassign").onclick = async () => {
    try {
      await updateDoc(doc(db,"clients",c.id), { claimedBy: S.me.name });
      c.claimedBy = S.me.name; toast("Reassigned to you."); openClient(id, mode);
    } catch(e){ console.error(e); toast("Couldn't reassign."); }
  };
  if ($("#arcbtn")) $("#arcbtn").onclick = async () => {
    const back = c.status === "archived";
    if (!back && !confirm(`Archive ${c.name || "this client"}? She disappears from the dashboard. You can bring her back from the Archived list.`)) return;
    try {
      await updateDoc(doc(db,"clients",c.id), {
        status: back ? (c.technical ? "done" : "new") : "archived",
        archivedBy: back ? null : S.me.name
      });
      await loadClients(mode);
      toast(back ? "Back on the floor." : "Archived.");
    } catch(e){ console.error(e); toast("Couldn't do that. Try Refresh."); }
  };
  bindRecord(c, "consult", mode);
  bindRecord(c, "plan", mode);
  if ($("#estnew")) bindEstimates(c, mode);
  if ($("#vadd")) bindVisits(c, mode);
}

function label(f){ return typeof f.l === "string" ? f.l : f.l[0]; }

function intakeReport(c){
  const a = c.answers || {};
  let out = "";
  for (const sec of INTAKE){
    const rows = sec.fields.filter(f => f.t !== "files").map(f => {
      let v = a[f.k];
      if (Array.isArray(v)) v = v.join(", ");
      if (f.k === "phone") v = maskPhone(v);
      if (f.k === "email") v = maskEmail(v);
      return `<div class="ans"><dt>${esc(sec.n[0])} — ${esc(f.l[0])}</dt>
        <dd class="${v?"":"none"}">${v?esc(v):"—"}</dd></div>`;
    }).join("");
    out += rows;
  }
  const photos = c.photos || {};
  const galleries = ["photoFront","photoBack","photoInspo"].map(k => {
    const urls = photos[k] || [];
    if (!urls.length) return "";
    const t = k === "photoFront" ? "Front" : k === "photoBack" ? "Back, opened" : "Her inspiration";
    return `<h3 class="sec-h">${t}</h3><div class="gal">${
      urls.map(u => `<a data-sp="${esc(u)}" target="_blank" rel="noopener"><img data-sp="${esc(u)}" alt="${t}"></a>`).join("")}</div>`;
  }).join("");
  const media = a.mediaRelease ? `<div class="ans"><dt>Photo & video release</dt><dd>${esc(a.mediaRelease)}</dd></div>` : "";
  const sig = c.signature ? `<h3 class="sec-h">Signed</h3>
    <p style="color:var(--slate);font-size:.88rem">${esc(a.signName||"")} · ${when(c.signedAt)}</p>
    <img data-sp="${esc(c.signature)}" alt="Signature" style="max-width:280px;background:#fff;border:1px solid var(--mist);border-radius:4px">` : "";
  return `<h3 class="sec-h">Photos</h3>${galleries || `<div class="empty">No photos.</div>`}
    <h3 class="sec-h">Her answers</h3><dl style="margin:0">${out}${media}</dl>${sig}`;
}

function vdate(d){
  const x = d?.toDate ? d.toDate() : (d ? new Date(d) : null);
  return x ? x.toLocaleDateString(undefined,{year:"numeric",month:"short",day:"numeric"}) : "";
}

// Accepts either a flat list or grouped list, so old configs keep working.
function svcGroups(){
  const sv = CONFIG.services || [];
  if (sv.length && typeof sv[0] === "object" && sv[0].items) return sv;
  return [{ group: "Services", items: sv }];
}

function visitsBlock(c){
  const visits = [...(c.visits || [])].reverse();   // newest first
  const past = visits.map((v,i) => {
    const rows = VISIT_FIELDS.filter(f => v[f.k]).map(f =>
      `<div class="ans"><dt>${esc(f.l)}</dt><dd>${esc(v[f.k])}</dd></div>`).join("");
    const pics = VISIT_PHOTOS.map(f => {
      const have = v.photos?.[f.k] || [];
      if (!have.length) return "";
      return `<h3 class="sec-h" style="font-size:1.05rem">${f.l}</h3><div class="gal">${have.map(pth =>
        `<a data-sp="${esc(pth)}" target="_blank" rel="noopener"><img data-sp="${esc(pth)}" alt="${f.l}"></a>`).join("")}</div>`;
    }).join("");
    return `<div style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.2rem;margin-bottom:.6rem">
      <div style="display:flex;gap:.75rem;align-items:baseline;flex-wrap:wrap">
        <b style="font-weight:500">${esc(Array.isArray(v.service) ? v.service.join("  +  ") : (v.service || "Visit"))}</b>
        <span class="meta">${vdate(v.date)}${v.stylist ? " · " + esc(v.stylist) : ""}${
          v.finishedBy ? " · finished by " + esc(v.finishedBy) : ""}</span>
      </div>
      <dl style="margin:.5rem 0 0">${rows}</dl>${pics}
    </div>`;
  }).join("");

  const d = c.visitDraft || {};
  const hasDraft = Object.keys(d).filter(k => k !== "photos" && k !== "by").length > 0;
  const dsvc = d.service || [];
  const form = `<div id="visitform" ${hasDraft ? "" : "hidden"} style="border:1px solid var(--toner);background:var(--white);border-radius:4px;padding:1.2rem;margin-top:.6rem">
    ${hasDraft ? `<p class="stepnote"><b>Visit in progress</b>${d.by ? " — started by " + esc(d.by) : ""}. Not finished yet. · Visita sin terminar.</p>` : ""}
    <div class="f"><span class="q">Services · Servicios</span>
      <span class="hint">Tick everything she had done today. · Marque todo lo que se realizó hoy.</span>
      <input type="text" id="svcfilter" placeholder="Filter services · Filtrar servicios" style="margin-bottom:.6rem">
      <div id="svcpick">${svcGroups().map((g,gi) => `
        <details class="svcgroup" data-g="${gi}"${gi===0?" open":""}>
          <summary>${esc(g.group)} <span class="pill" data-count="${gi}"></span></summary>
          <div class="choices" style="margin-top:.5rem">${g.items.map(sv =>
            `<label class="ch"><input type="checkbox" data-vsvc value="${esc(sv)}" ${dsvc.includes(sv)?"checked":""}><span>${esc(sv)}</span></label>`).join("")}
          </div>
        </details>`).join("")}
      </div></div>
    ${VISIT_FIELDS.map(f => f.t === "textarea"
      ? `<div class="f"><label>${esc(f.l)}</label>${f.hint?`<span class="hint">${esc(f.hint)}</span>`:""}<textarea data-v="${f.k}">${esc(d[f.k]||"")}</textarea></div>`
      : `<div class="f"><label>${esc(f.l)}</label>${f.hint?`<span class="hint">${esc(f.hint)}</span>`:""}<input type="text" data-v="${f.k}" value="${esc(d[f.k]||"")}"></div>`).join("")}
    ${VISIT_PHOTOS.map(f => `<div class="f"><span class="q">${esc(f.l)}</span>
      ${(d.photos?.[f.k]||[]).length ? `<div class="gal">${d.photos[f.k].map(pth =>
        `<a data-sp="${esc(pth)}" target="_blank" rel="noopener"><img data-sp="${esc(pth)}" alt=""></a>`).join("")}</div>` : ""}
      <div class="drop"><p>Up to ${f.max} · Hasta ${f.max}</p>
      <input type="file" accept="image/*" multiple data-vp="${f.k}" data-max="${f.max}">
      <div class="thumbs" id="vth_${f.k}"></div></div></div>`).join("")}
    <div class="nav"><button class="btn ghost" id="vhold">Save progress · Guardar avance</button>
      <button class="btn" id="vsave">Finish visit · Terminar visita</button>
      <span class="count" id="vmsg"></span></div>
    <p class="hint" style="margin-top:.6rem">Save progress keeps it open — take the before photos, go see another client, come back for the after. Finishing locks it with today's date. · Guardar avance la deja abierta.</p>
  </div>`;

  return `<h3 class="sec-h" style="border-top:2px solid var(--graphite);padding-top:1.5rem">
      Visits · Visitas ${visits.length ? `<span class="pill">${visits.length}</span>` : ""}</h3>
    <p class="stepnote">Every appointment after the consultation. · Cada cita después de la consulta.</p>
    <button class="btn${hasDraft ? " ghost" : ""}" id="vadd">${
      hasDraft ? "Continue visit · Continuar visita" : "Log a visit · Registrar visita"}</button>
    ${form}
    <div style="margin-top:1rem">${past || `<div class="empty">No visits logged yet. · Aún no hay visitas.</div>`}</div>`;
}

function bindVisits(c, mode){
  const picked = {};
  $$("input[data-vp]").forEach(el => el.onchange = () => {
    const k = el.dataset.vp, max = +el.dataset.max;
    let fs = [...el.files].filter(f => f.type.startsWith("image/"));
    if (fs.length > max){ fs = fs.slice(0,max); toast(`Kept the first ${max}.`); }
    picked[k] = fs;
    const box = $("#vth_"+k); box.innerHTML = "";
    fs.forEach(f => { const i = new Image(); i.src = URL.createObjectURL(f); box.appendChild(i); });
  });

  const counts = () => $$(".svcgroup").forEach(g => {
    const n = $$("input[data-vsvc]", g).filter(i => i.checked).length;
    const pill = $("[data-count]", g);
    if (pill){ pill.textContent = n ? n + " selected" : ""; pill.style.display = n ? "" : "none"; }
  });
  $$("input[data-vsvc]").forEach(i => i.addEventListener("change", counts));
  counts();

  const sf = $("#svcfilter");
  if (sf) sf.oninput = () => {
    const q = sf.value.toLowerCase().trim();
    $$(".svcgroup").forEach(g => {
      let shown = 0;
      $$(".ch", g).forEach(lab => {
        const hit = !q || lab.textContent.toLowerCase().includes(q);
        lab.style.display = hit ? "" : "none";
        if (hit) shown++;
      });
      g.style.display = shown ? "" : "none";
      if (q) g.open = true;
    });
  };

  $("#vadd").onclick = () => {
    const f = $("#visitform");
    f.hidden = !f.hidden;
    if (!f.hidden) f.scrollIntoView({behavior:"smooth", block:"start"});
  };

  const collect = () => {
    const v = { photos: (c.visitDraft && c.visitDraft.photos) || {} };
    v.service = $$("[data-vsvc]").filter(el => el.checked).map(el => el.value);
    $$("[data-v]").forEach(el => { if (el.value.trim()) v[el.dataset.v] = el.value.trim(); });
    return v;
  };

  const uploadShots = async (v) => {
    for (const k of Object.keys(picked)){
      if (!picked[k].length) continue;
      $("#vmsg").textContent = "Uploading photos…";
      const urls = [];
      for (const [i,file] of picked[k].entries()){
        const p = sref(store, `clients/${c.id}/${k}_${Date.now()}_${i}.jpg`);
        await uploadBytes(p, file);
        urls.push(p.fullPath);
      }
      v.photos[k] = [...(v.photos[k] || []), ...urls];
    }
    return v;
  };

  $("#vhold").onclick = async () => {
    $("#vmsg").textContent = "Saving…";
    try {
      const v = await uploadShots(collect());
      v.by = (c.visitDraft && c.visitDraft.by) || S.me.name;
      await updateDoc(doc(db,"clients",c.id), { visitDraft: v });
      c.visitDraft = v;
      toast("Progress saved. Come back any time.");
      openClient(c.id, mode);
    } catch(e){ console.error(e); $("#vmsg").textContent = "Didn't save. Try again."; }
  };

  $("#vsave").onclick = async () => {
    const v = collect();
    if (!v.service.length){ $("#vmsg").textContent = "Pick at least one service. · Marque al menos un servicio."; return; }
    if (!confirm("Finish this visit? It gets locked with today's date. · ¿Terminar la visita? Quedará cerrada.")) return;

    $("#vsave").disabled = true; $("#vmsg").textContent = "Saving…";
    try {
      await uploadShots(v);
      v.date = new Date();
      v.stylist = (c.visitDraft && c.visitDraft.by) || S.me.name;
      if (v.stylist !== S.me.name) v.finishedBy = S.me.name;
      const visits = [...(c.visits || []), v];
      await updateDoc(doc(db,"clients",c.id), {
        visits, visitDraft: null, lastVisitAt: serverTimestamp()
      });
      c.visits = visits; c.visitDraft = null;
      toast("Visit saved.");
      openClient(c.id, mode);
    } catch(e){
      console.error(e);
      $("#vmsg").textContent = "Didn't save. Try again.";
      $("#vsave").disabled = false;
    }
  };
}

// Photos are stored as paths. Only signed-in staff may read them, so we swap
// each path for a real download link once the profile is rendered.
async function hydratePhotos(){
  const nodes = $$("[data-sp]");
  const cache = {};
  for (const el of nodes){
    const path = el.dataset.sp;
    if (!path) continue;
    if (path.startsWith("http")){            // older records saved full URLs
      if (el.tagName === "IMG") el.src = path; else el.href = path;
      continue;
    }
    try {
      if (!cache[path]) cache[path] = await getDownloadURL(sref(store, path));
      if (el.tagName === "IMG") el.src = cache[path]; else el.href = cache[path];
    } catch(e){
      console.error("photo", path, e);
      if (el.tagName === "IMG") el.alt = "Photo unavailable";
    }
  }
}

function recFieldHTML(f, v){
  const req = f.req ? ` <span style="color:var(--bad)">*</span>` : "";
  if (f.t === "radio")
    return `<div class="f"><span class="q">${f.l}${req}</span><div class="choices inline">${
      f.o.map(o => `<label class="ch"><input type="radio" name="r_${f.k}" data-r="${f.k}" value="${esc(o)}" ${v===o?"checked":""}><span>${esc(o)}</span></label>`).join("")
    }</div></div>`;
  if (f.t === "textarea")
    return `<div class="f"><label>${f.l}${req}</label><textarea data-r="${f.k}">${esc(v||"")}</textarea></div>`;
  return `<div class="f"><label>${f.l}${req}</label><input type="text" data-r="${f.k}" value="${esc(v||"")}"></div>`;
}

function recReadOnly(cfg, r, i){
  const rows = cfg.sections.flatMap(sec => sec.fields).filter(f => r[f.k])
    .map(f => `<div class="ans"><dt>${esc(f.l)}</dt><dd>${esc(r[f.k])}</dd></div>`).join("");
  const pics = !cfg.photos ? "" : TECH_PHOTOS.map(f => {
    const have = r.photos?.[f.k] || [];
    if (!have.length) return "";
    return `<h3 class="sec-h" style="font-size:1.05rem">${esc(f.l)}</h3><div class="gal">${have.map(pth =>
      `<a data-sp="${esc(pth)}" target="_blank" rel="noopener"><img data-sp="${esc(pth)}" alt=""></a>`).join("")}</div>`;
  }).join("");
  return `<div style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.2rem;margin-bottom:.6rem">
    <div style="display:flex;gap:.75rem;align-items:baseline;flex-wrap:wrap">
      <b style="font-weight:500">#${i+1}</b>
      <span class="meta">${vdate(r.at)}${r.by ? " · " + esc(r.by) : ""}</span>
      ${r.candidate ? `<span class="pill">${esc(r.candidate)}</span>` : ""}
    </div>
    <dl style="margin:.5rem 0 0">${rows || `<div class="ans"><dd class="none">Nothing recorded.</dd></div>`}</dl>${pics}
  </div>`;
}

// Records saved before consultations and plans were split apart.
function legacyTech(c){
  const t = c.technical || {};
  const all = [...TECH_CONSULT, ...TECH_PLAN].flatMap(sec => sec.fields);
  const rows = all.filter(f => t[f.k]).map(f =>
    `<div class="ans"><dt>${esc(f.l)}</dt><dd>${esc(t[f.k])}</dd></div>`).join("");
  const pics = TECH_PHOTOS.map(f => {
    const have = t.photos?.[f.k] || [];
    if (!have.length) return "";
    return `<h3 class="sec-h" style="font-size:1.05rem">${esc(f.l)}</h3><div class="gal">${have.map(pth =>
      `<a data-sp="${esc(pth)}" target="_blank" rel="noopener"><img data-sp="${esc(pth)}" alt=""></a>`).join("")}</div>`;
  }).join("");
  return `<h3 class="sec-h" style="border-top:2px solid var(--graphite);padding-top:1.5rem">
      Earlier record · Registro anterior <span class="pill">read only</span></h3>
    <p class="stepnote">Saved before consultations and plans were separated. · Guardado antes de separar consulta y plan.</p>
    <div style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.2rem">
      <dl style="margin:0">${rows}</dl>${pics}</div>`;
}

function recordBlock(c, kind){
  const cfg = RECORDS[kind];
  const done = [...(c[cfg.key] || [])].reverse();
  const draft = c[cfg.draft] || {};
  const hasDraft = Object.keys(draft).filter(k => k !== "photos").length > 0;

  const shots = !cfg.photos ? "" : TECH_PHOTOS.map(f => {
    const have = draft.photos?.[f.k] || [];
    return `<div class="f"><span class="q">${esc(f.l)}</span><span class="hint">${esc(f.hint)}</span>
      ${have.length ? `<div class="gal">${have.map(pth =>
        `<a data-sp="${esc(pth)}" target="_blank" rel="noopener"><img data-sp="${esc(pth)}" alt=""></a>`).join("")}</div>` : ""}
      <div class="drop"><p>Up to ${f.max} · Hasta ${f.max}</p>
      <input type="file" accept="image/*" multiple data-tp="${f.k}" data-max="${f.max}">
      <div class="thumbs" id="tth_${f.k}"></div></div></div>`;
  }).join("");

  const form = `<div id="recform_${kind}" ${hasDraft ? "" : "hidden"} style="border:1px solid var(--toner);background:var(--white);border-radius:4px;padding:1.2rem;margin-top:.6rem">
    ${hasDraft ? `<p class="stepnote"><b>Draft in progress</b>${draft.by ? " — started by " + esc(draft.by) : ""}. Not submitted yet. · Borrador sin enviar.</p>` : ""}
    ${cfg.sections.map(sec => `<h3 class="sec-h">${esc(sec.n)}</h3>
      ${sec.fields.map(f => recFieldHTML(f, draft[f.k])).join("")}`).join("")}
    ${shots}
    <div class="nav">
      <button class="btn ghost" data-save="${kind}">Save progress · Guardar avance</button>
      <button class="btn" data-submit="${kind}">Save &amp; submit · Guardar y enviar</button>
      <span class="count" id="recmsg_${kind}"></span>
    </div>
    <p class="hint" style="margin-top:.6rem">Submitting locks this ${cfg.one} with today's date and your name. Anything later goes in a new one. · Al enviar se cierra con la fecha y su nombre.</p>
  </div>`;

  return `<h3 class="sec-h" style="border-top:2px solid var(--graphite);padding-top:1.5rem">
      ${esc(cfg.title)} ${done.length ? `<span class="pill">${done.length}</span>` : ""}</h3>
    <p class="stepnote">${esc(cfg.note)}</p>
    <button class="btn${hasDraft ? " ghost" : ""}" data-open="${kind}">${
      hasDraft ? "Continue draft · Continuar borrador" : `New ${cfg.one}`}</button>
    ${form}
    <div style="margin-top:1rem">${done.map((r,i) => recReadOnly(cfg, r, done.length-1-i)).join("")}</div>`;
}

function bindRecord(c, kind, mode){
  const cfg = RECORDS[kind];
  const picked = {};
  const scope = $("#recform_" + kind);
  if (!scope) return;

  $$("input[data-tp]", scope).forEach(el => el.onchange = () => {
    const k = el.dataset.tp, max = +el.dataset.max;
    let fs = [...el.files].filter(f => f.type.startsWith("image/"));
    if (fs.length > max){ fs = fs.slice(0,max); toast(`Kept the first ${max}.`); }
    picked[k] = fs;
    const box = $("#tth_"+k, scope); box.innerHTML = "";
    fs.forEach(f => { const i = new Image(); i.src = URL.createObjectURL(f); box.appendChild(i); });
  });

  $(`[data-open="${kind}"]`).onclick = () => {
    scope.hidden = !scope.hidden;
    if (!scope.hidden) scope.scrollIntoView({behavior:"smooth", block:"start"});
  };

  const collect = () => {
    const r = { photos: (c[cfg.draft] && c[cfg.draft].photos) || {} };
    $$("[data-r]", scope).forEach(el => {
      if (el.type === "radio"){ if (el.checked) r[el.dataset.r] = el.value; }
      else if (el.value.trim()) r[el.dataset.r] = el.value.trim();
    });
    return r;
  };

  const upload = async (r, msg) => {
    for (const k of Object.keys(picked)){
      if (!picked[k].length) continue;
      msg.textContent = "Uploading photos…";
      const urls = [];
      for (const [i,file] of picked[k].entries()){
        const p = sref(store, `clients/${c.id}/${k}_${Date.now()}_${i}.jpg`);
        await uploadBytes(p, file);
        urls.push(p.fullPath);
      }
      r.photos[k] = [...(r.photos[k] || []), ...urls];
    }
    return r;
  };

  $(`[data-save="${kind}"]`).onclick = async () => {
    const msg = $("#recmsg_" + kind);
    msg.textContent = "Saving…";
    try {
      const r = await upload(collect(), msg);
      r.by = (c[cfg.draft] && c[cfg.draft].by) || S.me.name;
      await updateDoc(doc(db,"clients",c.id), { [cfg.draft]: r });
      c[cfg.draft] = r;
      toast("Progress saved.");
      openClient(c.id, mode);
    } catch(e){ console.error(e); msg.textContent = "Didn't save. Try again."; }
  };

  $(`[data-submit="${kind}"]`).onclick = async () => {
    const msg = $("#recmsg_" + kind);
    const r = collect();
    if (cfg.req && !r[cfg.req]){ msg.textContent = cfg.reqMsg; return; }
    if (!confirm(`Submit this ${cfg.one}? It gets locked with today's date and can't be edited. · ¿Enviar? Quedará cerrada.`)) return;
    msg.textContent = "Saving…";
    try {
      await upload(r, msg);
      r.by = S.me.name; r.at = new Date(); r.submitted = true;
      const list = [...(c[cfg.key] || []), r];
      const patch = { [cfg.key]: list, [cfg.draft]: null };
      if (kind === "consult") patch.status = "done";
      await updateDoc(doc(db,"clients",c.id), patch);
      c[cfg.key] = list; c[cfg.draft] = null;
      if (kind === "consult") c.status = "done";
      toast("Submitted.");
      openClient(c.id, mode);
    } catch(e){ console.error(e); msg.textContent = "Didn't save. Try again."; }
  };
}


/* ============================================================
   ESTIMATES · ESTIMADOS (owners only)
   Each estimate is its own document in "estimates" with a random ID.
   The client opens it at CONFIG.estimates.pageUrl?e=ID. That page can
   read ONE estimate by its ID and nothing else in the database.
   ============================================================ */

const EST = CONFIG.estimates;
const estUrl = id => `${EST.pageUrl}?e=${encodeURIComponent(id)}`;
const r2 = n => Math.round((+n || 0) * 100) / 100;
function money(n){
  const v = r2(n);
  return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
}

// The one place the estimate math lives. The client page shows these numbers as saved.
function estCalc(e){
  const sp       = +EST.sessionPrice || 0;
  const pcc      = Math.max(0, parseInt(e.pcc, 10) || 0);
  const prep     = Math.max(0, parseInt(e.prep, 10) || 0);
  const credit   = +e.credit || 0;
  // The bundle is the two numbers you type, added up. Estimates saved before
  // this split stored one total, so fall back to that when the parts are blank.
  const bMain    = String(e.bundleMain ?? "").trim();
  const bSess    = String(e.bundleSessions ?? "").trim();
  const split    = bMain !== "" || bSess !== "";
  const bundleMain     = +e.bundleMain || 0;
  const bundleSessions = +e.bundleSessions || 0;
  const bundle   = split ? bundleMain + bundleSessions : (+e.bundle || 0);
  const main     = +e.mainPrice || 0;
  const pct      = e.depositPct === "" || e.depositPct == null ? EST.depositPct : +e.depositPct;
  const deposit  = Math.round(bundle * pct / 100);
  // Her consultation credit comes off the FINAL payment. She pays the full
  // deposit at booking. If the credit is bigger than that final payment, the
  // leftover rolls back onto the deposit so the total is still bundle − credit.
  let payBefore = deposit;
  let balance   = bundle - deposit - credit;
  if (balance < 0){ payBefore = Math.max(0, payBefore + balance); balance = 0; }
  const financedBase = bundle - credit;
  const fee          = Math.round(financedBase * (+EST.financingPct || 0)) / 100;
  const separate     = (pcc + prep) * sp + main;
  return {
    pcc, prep, sessionPrice: sp, credit, bundle, mainPrice: main, depositPct: pct,
    bundleMain: split ? bundleMain : null, bundleSessions: split ? bundleSessions : null,
    deposit, payBefore, balance, financedBase, fee, financedTotal: r2(financedBase + fee),
    financingPct: +EST.financingPct || 0,
    separate, separateNet: separate - credit,
    bundleNet: bundle - credit,
    ok: bundle > 0 && main > 0 && bundle < separate
  };
}

// Firestore refuses a document containing undefined. One field left out of
// the defaults would otherwise fail the whole save, so drop them first.
function noUndefined(v){
  if (Array.isArray(v)) return v.map(noUndefined);
  if (v && typeof v === "object" && !(v instanceof Date) && !v._methodName){
    const out = {};
    for (const [key, val] of Object.entries(v)) if (val !== undefined) out[key] = noUndefined(val);
    return out;
  }
  return v;
}

// What the PCCs and prep come to at the standard bundle rates.
function autoBundleSessions(e){
  return (Math.max(0, parseInt(e.pcc, 10) || 0) * (+EST.bundlePccPrice  || 0))
       + (Math.max(0, parseInt(e.prep, 10) || 0) * (+EST.bundlePrepPrice || 0));
}

// "2 × PCC", "1 × Grey Prep & Strength" — the sessions spelled out.
function sessionItems(k){
  return [
    { n: +k.pcc  || 0, label: EST.pccLabel  || "PCC" },
    { n: +k.prep || 0, label: EST.prepLabel || "Prep" }
  ].filter(x => x.n > 0).map(x => ({ ...x, total: x.n * (+k.sessionPrice || 0) }));
}

// Tier 0 uses mainPrice/bundle; tier 1 uses the second stylist's prices.
function tierInput(e, i){
  return i === 0 ? e : { ...e,
    mainPrice:      e.tier2MainPrice,
    bundleMain:     e.tier2BundleMain,
    bundleSessions: e.tier2BundleSessions,
    bundle:         "" };
}
// Blank is fine when there's only one price: her page then shows no name at all.
function tierName(e, i){
  return String((i === 0 ? e.tier1Label : e.tier2Label) || "").trim();
}
const hasTier2 = e => !!e.tier2on && +e.tier2Bundle > 0 && +e.tier2MainPrice > 0;

function estDefaults(c){
  const last = (c.consultations || []).slice(-1)[0] || {};
  return {
    firstName: (c.name || "").trim().split(/\s+/)[0] || "",
    service: EST.services[0].name,
    mainPrice: EST.services[0].price ?? "",
    consultDate: "",
    consultIdx: 0,
    pcc: 2, prep: 1,
    bundle: "",   // older estimates stored one total here; kept so Edit works
    bundleMain: "", bundleSessions: autoBundleSessions({ pcc: 2, prep: 1 }),
    depositPct: EST.depositPct,
    tier1Label: "",
    tier2on: false,
    tier2Label: "",
    tier2MainPrice: "",
    tier2BundleMain: "", tier2BundleSessions: "",
    evalText: last.strandResult || "",
    hl1v: last.levelAchieved || "", hl1l: last.levelAchieved ? "altura alcanzada en la prueba de mecha" : "",
    hl2v: "", hl2l: "",
    includes: EST.includes.join("\n"),
    closing: ""
  };
}

function estimatesBlock(c){
  const list = [...(c.estimates || [])].reverse();
  const rows = list.map(e => `
    <div style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.2rem;margin-bottom:.6rem">
      <div style="display:flex;gap:.75rem;align-items:baseline;flex-wrap:wrap">
        <b style="font-weight:500">${esc(e.service || "Estimado")} · ${money(e.bundle)}</b>
        ${e.nTiers > 1 ? `<span class="pill">2 estilistas</span>` : ""}
        <span class="meta">${vdate(e.at)}${e.by ? " · " + esc(e.by) : ""}</span>
      </div>
      <p class="hint" data-eststats="${esc(e.id)}" style="margin:.4rem 0 .6rem">Checking if she opened it… · Revisando…</p>
      <div style="display:flex;gap:.5rem;flex-wrap:wrap">
        ${canSeeContacts() ? `<button class="btn" data-estsend="${esc(e.id)}">Send on WhatsApp · Enviar</button>` : ""}
        <button class="btn ghost" data-estcopy="${esc(e.id)}">Copy message · Copiar mensaje</button>
        <a class="btn ghost" href="${esc(estUrl(e.id) + "&p=1")}" target="_blank" rel="noopener">View · Ver</a>
        <button class="btn ghost" data-estedit="${esc(e.id)}">Edit · Editar</button>
      </div>
    </div>`).join("");

  return `<h3 class="sec-h" style="border-top:2px solid var(--graphite);padding-top:1.5rem">
      Estimates · Estimados ${list.length ? `<span class="pill">${list.length}</span>` : ""}</h3>
    <p class="stepnote">The price quote she gets after her consultation. Fill in the plan and prices; the math is automatic. Editing keeps the same link. · El presupuesto después de la consulta. Al editar, el link no cambia.</p>
    <button class="btn" id="estnew">New estimate · Nuevo estimado</button>
    <div id="estform" hidden style="border:1px solid var(--toner);background:var(--white);border-radius:4px;padding:1.2rem;margin-top:.6rem"></div>
    <div style="margin-top:1rem">${rows || `<div class="empty">No estimates yet. · Aún no hay estimados.</div>`}</div>`;
}

function estFormHTML(e, editing){
  const svcOpts = EST.services.map(s => `<option value="${esc(s.name)}">`).join("");
  const consults = EST.consults.map((o,i) => `<label class="ch"><input type="radio" name="estc" data-e="consultIdx" value="${i}" ${+e.consultIdx === i ? "checked" : ""}><span>${esc(o.label)}</span></label>`).join("");
  const inp = (k, label, type="text", hint="") => `<div class="f"><label for="est_${k}">${label}</label>${hint ? `<span class="hint">${hint}</span>` : ""}
      <input type="${type}" id="est_${k}" data-e="${k}" value="${esc(e[k] ?? "")}" ${type === "number" ? `inputmode="decimal" min="0"` : ""}></div>`;
  const ta = (k, label, hint="") => `<div class="f"><label for="est_${k}">${label}</label>${hint ? `<span class="hint">${hint}</span>` : ""}
      <textarea id="est_${k}" data-e="${k}">${esc(e[k] ?? "")}</textarea></div>`;
  return `
    <p class="stepnote"><b>${editing ? "Editing this estimate. Her link stays the same. · Editando: el link no cambia." : "New estimate · Nuevo estimado"}</b></p>
    <h3 class="sec-h">Client · Clienta</h3>
    ${inp("firstName", "Name on her page · Nombre en su página", "text", "Exactly as she writes it. · Exactamente como ella lo escribe.")}
    ${inp("consultDate", "Consultation date · Fecha de la consulta", "date")}
    <div class="f"><span class="q">Consultation · Consulta</span><div class="choices">${consults}</div></div>

    <h3 class="sec-h">Plan · Plan</h3>
    <div class="f"><label for="est_service">Main service · Servicio principal</label>
      <span class="hint">Pick one or type another. · Elija o escriba otro.</span>
      <input type="text" id="est_service" data-e="service" list="estsvc" value="${esc(e.service ?? "")}"><datalist id="estsvc">${svcOpts}</datalist></div>
    ${inp("pcc", "PCC sessions · Sesiones de PCC", "number")}
    ${inp("prep", "Prep appointments (detox / protein) · Citas de preparación", "number")}

    <h3 class="sec-h">Prices · Precios</h3>
    <div class="f"><label for="est_tier1Label">Which stylist is this price for? · ¿De qué estilista es este precio?</label>
      <span class="hint">Leave it blank if you're only sending one price and don't need to name anyone. · Déjelo vacío si solo envía un precio.</span>
      <input type="text" id="est_tier1Label" data-e="tier1Label" list="eststylists" value="${esc(e.tier1Label ?? "")}">
      <datalist id="eststylists">${EST.stylists.map(n => `<option value="${esc(n)}">`).join("")}</datalist></div>
    <p class="hint" style="margin:0 0 .8rem">In the bundle · En el paquete</p>
    ${inp("bundleMain", "Main service · Servicio principal", "number", "Your bundle price for the big service on its own. · Su precio del servicio grande dentro del paquete.")}
    ${inp("bundleSessions", "All the PCCs and prep together · PCC y preparación, en total", "number",
      `Filled in for you at the standard bundle rates — ${money(EST.bundlePccPrice)} a PCC, ${money(EST.bundlePrepPrice)} a prep. Type over it for a one-off price. · Se calcula solo; puede cambiarlo.`)}
    <p class="hint" style="margin:1rem 0 .8rem">On its own · Por separado</p>
    ${inp("mainPrice", "Retail price of the main service · Precio de lista del servicio principal", "number", `What it costs outside a bundle. PCC and prep are ${money(EST.sessionPrice)} each at retail. · Fuera del paquete. PCC y preparación: ${money(EST.sessionPrice)} c/u.`)}

    <label class="ch" style="margin:.2rem 0 .8rem">
      <input type="checkbox" data-e="tier2on" ${e.tier2on ? "checked" : ""}>
      <span>Show a second stylist too, so she can choose between them · Mostrar una segunda estilista para que elija</span>
    </label>
    <div id="esttier2" ${e.tier2on ? "" : "hidden"} style="border-left:3px solid var(--mist);padding-left:1rem;margin-bottom:1rem">
      <div class="f"><label for="est_tier2Label">The other stylist · La otra estilista</label>
        <input type="text" id="est_tier2Label" data-e="tier2Label" list="eststylists" value="${esc(e.tier2Label ?? "")}"></div>
      ${inp("tier2BundleMain", "In the bundle — main service · En el paquete — servicio principal", "number")}
      ${inp("tier2BundleSessions", "In the bundle — PCCs and prep together · PCC y preparación, en total", "number")}
      ${inp("tier2MainPrice", "Retail price of the main service · Precio de lista", "number")}
    </div>

    ${inp("depositPct", "Deposit % · % de depósito", "number")}
    <div id="estcalc"></div>

    <h3 class="sec-h">Her page · Su página</h3>
    ${ta("evalText", "What we found · Lo que encontramos", "From Gretell's notes. Write to her as \"tú\". · De las notas de Gretell, en \"tú\".")}
    <div style="display:grid;grid-template-columns:7rem 1fr;gap:0 .75rem">
      ${inp("hl1v", "Big number 1", "text", "e.g. 7 · 6")}${inp("hl1l", "Its label · Etiqueta", "text", "e.g. altura en la prueba de mecha")}
      ${inp("hl2v", "Big number 2", "text")}${inp("hl2l", "Its label · Etiqueta", "text")}
    </div>
    ${ta("includes", "What the main day includes · Qué incluye el día principal", "One per line. · Uno por línea.")}
    ${ta("closing", "Closing line · Frase final", "Gretell's closing sentence. Optional. · Opcional.")}

    <div class="nav">
      <button class="btn" id="estsave">${editing ? "Save changes · Guardar cambios" : "Create estimate · Crear estimado"}</button>
      <button class="btn ghost" id="estcancel">Cancel · Cancelar</button>
      <span class="count" id="estmsg"></span>
    </div>`;
}

function estCalcHTML(e){
  const row = (a,b,strong) => `<div class="ans"><dt>${a}</dt><dd${strong ? ` style="font-weight:600"` : ""}>${b}</dd></div>`;

  const one = (i) => {
    const k = estCalc(tierInput(e, i));
    const who = tierName(e, i);
    if (!k.bundle || !k.mainPrice)
      return `<p class="hint">Enter the bundle and the full price${who ? ` for ${esc(who)}` : ""}. · Faltan los precios.</p>`;
    const items = sessionItems(k).map(x => row(`${x.n} × ${esc(x.label)}`, money(x.total))).join("");
    return `<div style="border:1px solid ${k.ok ? "var(--mist)" : "var(--bad)"};border-radius:4px;padding:1rem 1.1rem;margin:.5rem 0 1rem">
      ${who ? `<b style="font-weight:500">${esc(who)}</b>` : ""}
      ${k.ok ? "" : `<p style="color:var(--bad);margin:.5rem 0 .6rem"><b>The bundle has to cost less than paying per session (${money(k.separate)}).</b> Raise the full price or lower the bundle. · El paquete debe costar menos que por separado.</p>`}
      <dl style="margin:.4rem 0 0">
        ${row("Bundle · Paquete", money(k.bundle), true)}
        ${k.bundleMain != null ? row("— main service · servicio principal", money(k.bundleMain)) : ""}
        ${k.bundleSessions != null ? row("— PCCs and prep · PCC y preparación", money(k.bundleSessions)) : ""}
        ${row(`Deposit ${k.depositPct}% · Depósito`, money(k.deposit))}
        ${row("① At booking · Al reservar", money(k.payBefore), true)}
        ${k.credit ? row("− Consultation credit · Crédito", "−" + money(k.credit)) : ""}
        ${row("② Final appointment · Última cita", money(k.balance), true)}
        ${row(`Financed (${k.financingPct}% after credit) · Financiado`, `${money(k.financedBase)} + ${money(k.fee)} = <b>${money(k.financedTotal)}</b>`)}
        ${items}
        ${row("Main day · Día principal", money(k.mainPrice))}
        ${row("Per session total · Total por separado", `<b>${money(k.separateNet)}</b>`)}
      </dl></div>`;
  };

  return one(0) + (e.tier2on ? one(1) : "");
}

function bindEstimates(c, mode){
  const box = $("#estform");
  let editingId = null;
  let state = null;

  const read = () => {
    $$("[data-e]", box).forEach(el => {
      if (el.type === "radio"){ if (el.checked) state[el.dataset.e] = +el.value; }
      else if (el.type === "checkbox"){ state[el.dataset.e] = el.checked; }
      else state[el.dataset.e] = el.value;
    });
    const cons = EST.consults[+state.consultIdx || 0] || EST.consults[0];
    state.credit = cons.credit;
    return state;
  };

  const open = (e, id) => {
    editingId = id || null;
    state = { ...e };
    box.innerHTML = estFormHTML(state, !!id);
    box.hidden = false;
    const recalc = () => { $("#estcalc", box).innerHTML = estCalcHTML(read()); };
    let lastAuto = state.mainPrice;
    let lastAutoSess = String(state.bundleSessions ?? "");
    const syncSessions = () => {
      const v = String(autoBundleSessions(read()));
      [["#est_bundleSessions", lastAutoSess], ["#est_tier2BundleSessions", lastAutoSess]]
        .forEach(([sel, prev]) => {
          const el = $(sel, box);
          // Only overwrite while she hasn't typed her own number in.
          if (el && (el.value === "" || el.value === prev)) el.value = v;
        });
      lastAutoSess = v;
    };
    $$("[data-e]", box).forEach(el => el.addEventListener(
      el.type === "radio" || el.type === "checkbox" ? "change" : "input", () => {
      if (el.dataset.e === "pcc" || el.dataset.e === "prep") syncSessions();
      if (el.dataset.e === "tier2on"){
        if (el.checked) syncSessions();
        const t2 = $("#esttier2", box); if (t2) t2.hidden = !el.checked;
      }
      if (el.dataset.e === "service"){
        const hit = EST.services.find(s => s.name.toLowerCase() === el.value.trim().toLowerCase());
        const mp = $("#est_mainPrice", box);
        if (hit && hit.price != null && (mp.value === "" || String(mp.value) === String(lastAuto))){
          mp.value = hit.price; lastAuto = hit.price;
        }
      }
      recalc();
    }));
    recalc();
    $("#estcancel", box).onclick = () => { box.hidden = true; box.innerHTML = ""; };
    $("#estsave", box).onclick = save;
    box.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const save = async () => {
    const e = read();
    const msg = $("#estmsg", box);
    const k = estCalc(e);
    if (!e.firstName.trim()) { msg.textContent = "Add her name. · Falta el nombre."; return; }
    if (!e.service.trim())   { msg.textContent = "Add the main service. · Falta el servicio."; return; }
    if (!k.bundle || !k.mainPrice){ msg.textContent = "Fill in the bundle prices and the retail price. · Faltan los precios."; return; }
    if (!k.ok){ msg.textContent = "The bundle has to cost less than per session. · El paquete debe costar menos."; return; }
    if (e.tier2on){
      if (!tierName(e, 0) || !tierName(e, 1)){
        msg.textContent = "Name both stylists, or she won't know which price is which. · Ponga el nombre de ambas estilistas."; return; }
      if (!(estCalc(tierInput(e, 1)).bundle > 0) || !(+e.tier2MainPrice > 0)){
        msg.textContent = "Add both prices for the second stylist, or untick it. · Faltan los precios de la segunda opción."; return; }
      if (!estCalc(tierInput(e, 1)).ok){
        msg.textContent = "The second bundle has to cost less than per session. · El segundo paquete debe costar menos."; return; }
    }
    const cons = EST.consults[+e.consultIdx || 0] || EST.consults[0];
    const data = {
      clientId: c.id,
      firstName: e.firstName.trim(),
      service: e.service.trim(),
      consultDate: e.consultDate || "",
      consultWith: cons.with,
      consultIdx: +e.consultIdx || 0,
      evalText: (e.evalText || "").trim(),
      highlights: [[e.hl1v, e.hl1l], [e.hl2v, e.hl2l]].filter(h => String(h[0] || "").trim()).map(h => ({ v: String(h[0]).trim(), l: String(h[1] || "").trim() })),
      includes: String(e.includes || "").split("\n").map(s => s.trim()).filter(Boolean),
      closing: (e.closing || "").trim(),
      calc: k,                       // tier 1, kept so older estimates still open
      tiers: [0, ...(e.tier2on ? [1] : [])].map(i => ({
        label: tierName(e, i),
        mainPrice: +tierInput(e, i).mainPrice || 0,
        bundle:    +tierInput(e, i).bundle || 0,
        calc:      estCalc(tierInput(e, i))
      })),
      // raw form values, so Edit reopens exactly what was typed
      form: { firstName: e.firstName, service: e.service, mainPrice: e.mainPrice, consultDate: e.consultDate,
              consultIdx: +e.consultIdx || 0, pcc: e.pcc, prep: e.prep, depositPct: e.depositPct,
              bundle: e.bundle, bundleMain: e.bundleMain, bundleSessions: e.bundleSessions,
              tier1Label: e.tier1Label, tier2on: !!e.tier2on, tier2Label: e.tier2Label,
              tier2MainPrice: e.tier2MainPrice,
              tier2BundleMain: e.tier2BundleMain, tier2BundleSessions: e.tier2BundleSessions,
              evalText: e.evalText, hl1v: e.hl1v, hl1l: e.hl1l, hl2v: e.hl2v, hl2l: e.hl2l,
              includes: e.includes, closing: e.closing },
      updatedAt: serverTimestamp(),
      updatedBy: S.me.name
    };
    $("#estsave", box).disabled = true; msg.textContent = "Saving…";
    try {
      let id = editingId;
      const safe = noUndefined(data);
      if (id){
        await setDoc(doc(db, "estimates", id), safe, { merge: true });
      } else {
        const ref = doc(collection(db, "estimates"));
        id = ref.id;
        await setDoc(ref, { ...safe, createdAt: serverTimestamp(), createdBy: S.me.name });
      }
      const summary = { id, service: data.service, bundle: k.bundle, firstName: data.firstName,
                        nTiers: data.tiers.length,
                        consultWith: data.consultWith, consultDate: data.consultDate,
                        at: editingId ? ((c.estimates || []).find(x => x.id === id)?.at || new Date()) : new Date(),
                        by: editingId ? ((c.estimates || []).find(x => x.id === id)?.by || S.me.name) : S.me.name };
      const list = editingId
        ? (c.estimates || []).map(x => x.id === id ? summary : x)
        : [...(c.estimates || []), summary];
      await updateDoc(doc(db, "clients", c.id), { estimates: list });
      c.estimates = list;
      toast(editingId ? "Estimate updated. Same link. · Actualizado." : "Estimate created. · Estimado creado.");
      openClient(c.id, mode);
    } catch(err){
      console.error(err);
      msg.textContent = "Didn't save: " + (err && err.message ? err.message : "unknown error") + " · No se guardó.";
      $("#estsave", box).disabled = false;
    }
  };

  $("#estnew").onclick = () => {
    if (!box.hidden && !editingId){ box.hidden = true; box.innerHTML = ""; return; }
    open(estDefaults(c), null);
  };

  $$("[data-estedit]").forEach(b => b.onclick = async () => {
    const id = b.dataset.estedit;
    try {
      const snap = await getDoc(doc(db, "estimates", id));
      if (!snap.exists()){ toast("That estimate wasn't found."); return; }
      open({ ...estDefaults(c), ...(snap.data().form || {}) }, id);
    } catch(err){ console.error(err); toast("Couldn't open it. Try Refresh."); }
  });

  const message = e => {
    const first = e.firstName || (c.name || "").split(/\s+/)[0] || "";
    const consult = e.consultWith ? ` y por venir a tu consulta con ${e.consultWith}` : "";
    return `Hola ${first} 🤍 ¡Gracias por confiarnos tu transformación${consult}! Aquí tienes tu estimado personalizado con el plan recomendado y tu inversión:\n${estUrl(e.id)}\nCualquier pregunta, escríbenos por aquí.`;
  };
  const byId = id => (c.estimates || []).find(x => x.id === id) || { id };

  $$("[data-estsend]").forEach(b => b.onclick = () => {
    const digits = String(c.phone || c.answers?.phone || "").replace(/\D/g, "");
    if (!digits){ toast("No phone on file. Use Copy message. · Sin teléfono."); return; }
    const intl = digits.length === 10 ? "1" + digits : digits;
    window.open(`https://wa.me/${intl}?text=${encodeURIComponent(message(byId(b.dataset.estsend)))}`, "_blank", "noopener");
  });

  $$("[data-estcopy]").forEach(b => b.onclick = async () => {
    const text = message(byId(b.dataset.estcopy));
    try { await navigator.clipboard.writeText(text); toast("Copied. Paste it in WhatsApp. · Copiado."); }
    catch(_){ window.prompt("Copy this · Copie esto:", text); }
  });

  // Did she open it? Each visit to her page leaves a small event behind.
  $$("[data-eststats]").forEach(async p => {
    const id = p.dataset.eststats;
    try {
      const snap = await getDocs(collection(db, "estimates", id, "events"));
      const ev = snap.docs.map(d => d.data());
      const views = ev.filter(x => x.type === "view");
      if (!views.length){ p.textContent = "Not opened yet. · Aún no lo ha abierto."; return; }
      const last = views.map(x => x.at?.toDate ? x.at.toDate() : null).filter(Boolean).sort((a,b) => b - a)[0];
      const n = t => ev.filter(x => x.type === t).length;
      const bits = [`Opened ${views.length}× · Abierto ${views.length} ${views.length === 1 ? "vez" : "veces"}`];
      if (last) bits.push("last " + when({ toDate: () => last }).toLowerCase());
      if (n("tier2")) bits.push("compared both stylists · comparó ambas");
      if (n("opt2")) bits.push("looked at financing · vio financiamiento");
      if (n("opt3")) bits.push("looked at per session · vio por sesión");
      if (n("reserve")) bits.push(`<b>tapped "reservar" ${n("reserve")}×</b>`);
      p.innerHTML = bits.join(" · ");
    } catch(err){ console.error(err); p.textContent = ""; }
  });
}



/* ============================================================
   HER ESTIMATE · SU ESTIMADO
   Opened from the link in CONFIG.estimates.pageUrl?e=ID.
   Reads one estimate by its ID and nothing else. Numbers are
   shown exactly as they were saved, never recalculated here.
   ?p=1 on the end means a stylist is previewing: nothing logged.
   ============================================================ */

function estPagePath(){
  try { return new URL(EST.pageUrl).pathname.replace(/\/+$/, ""); } catch(_){ return ""; }
}
function onEstimatePage(){
  const here = location.pathname.replace(/\/+$/, "");
  const want = estPagePath();
  return !!want && here === want;
}
function estimateMissing(){
  estShell(`<div style="padding:4rem 0">
    <h2 class="steptitle">Aquí va tu estimado.</h2>
    <p class="stepnote">Ábrelo desde el enlace completo que te enviamos por WhatsApp.
      Si no lo encuentras, escríbenos y te lo reenviamos.</p>
    <a class="btn" href="${esc(EST.reserveUrl)}">Escríbenos</a></div>`);
}

const estLogged = {};
async function estLog(id, type){
  if (new URLSearchParams(location.search).get("p") === "1") return;  // stylist preview
  if (estLogged[type]) return;
  estLogged[type] = true;
  try { await addDoc(collection(db, "estimates", id, "events"), { type, at: serverTimestamp() }); }
  catch(err){ console.error("log", err); }
}

function estShell(inner){
  app.innerHTML = `<div class="ghs-wrap" style="max-width:40rem">${inner}</div>`;
}

async function estimateView(id){
  estShell(`<div class="empty" style="border:0">Cargando tu estimado…</div>`);
  let d;
  try {
    const snap = await getDoc(doc(db, "estimates", id));
    if (!snap.exists()){
      estShell(`<div style="padding:4rem 0">
        <h2 class="steptitle">No encontramos este estimado.</h2>
        <p class="stepnote">Puede que el enlace esté incompleto. Escríbenos y te lo enviamos de nuevo.</p>
        <a class="btn" href="${esc(EST.reserveUrl)}">Escríbenos</a></div>`);
      return;
    }
    d = snap.data();
  } catch(err){
    console.error(err);
    estShell(`<div style="padding:4rem 0">
      <h2 class="steptitle">No pudimos abrir tu estimado.</h2>
      <p class="stepnote">Revisa tu conexión e inténtalo de nuevo.</p></div>`);
    return;
  }

  // Older estimates have one set of numbers; newer ones carry a tier per stylist.
  const tiers = (d.tiers && d.tiers.length)
    ? d.tiers
    : [{ label: "", mainPrice: (d.calc || {}).mainPrice, bundle: (d.calc || {}).bundle, calc: d.calc || {} }];

  const card = (body, accent) =>
    `<div style="border:1px solid ${accent ? "var(--toner)" : "var(--mist)"};background:var(--white);
      border-radius:4px;padding:1.3rem 1.4rem;margin-bottom:.7rem">${body}</div>`;
  const line = (a, b, strong) =>
    `<div style="display:flex;justify-content:space-between;gap:1rem;padding:.35rem 0;
      ${strong ? "font-weight:600;" : "color:var(--slate);"}"><span>${a}</span><span>${b}</span></div>`;

  const hl = (d.highlights || []).filter(h => h.v).map(h => `
    <div style="flex:1 1 9rem;border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1rem">
      <div style="font-family:Newsreader,Georgia,serif;font-size:2rem;line-height:1">${esc(h.v)}</div>
      <div style="color:var(--slate);font-size:.9rem;margin-top:.3rem">${esc(h.l)}</div>
    </div>`).join("");

  const includes = (d.includes || []).map(i => `<li style="margin:0 0 .45rem">${esc(i)}</li>`).join("");

  // The three ways to pay, for whichever stylist she's looking at.
  const moneyHTML = (ti) => {
    const t = tiers[ti] || tiers[0];
    const k = t.calc || {};
    const items  = sessionItems(k);
    const saves  = Math.max(0, (k.separateNet || 0) - (k.bundleNet || 0));
    // She sees what the bundle contains, never what each piece costs inside it.
    const plan = `<ul style="margin:.2rem 0 1rem;padding-left:1.1rem;color:var(--slate);line-height:1.5">
           ${items.map(x => `<li style="margin:0 0 .35rem">${x.n} × ${esc(x.label)}</li>`).join("")}
           <li style="margin:0 0 .35rem">1 × ${esc(d.service || "día principal")}</li>
         </ul>`;
    return `
      ${card(`
        <div style="display:flex;justify-content:space-between;align-items:baseline;gap:1rem;flex-wrap:wrap">
          <b style="font-weight:500;font-size:1.1rem">Paquete completo</b>
          <span class="pill" style="background:var(--toner-soft);color:var(--toner);border-color:transparent">recomendado</span>
        </div>
        <div style="font-family:Newsreader,Georgia,serif;font-size:2.6rem;line-height:1.1;margin:.5rem 0 .4rem">
          ${money(k.bundle)}</div>
        ${plan}
        <div style="border-top:1px solid var(--mist);margin-top:.3rem;padding-top:.9rem">
          <p style="margin:0 0 .7rem;font-weight:500">Son solo dos pagos</p>
          ${line("Al reservar — depósito del " + (k.depositPct || 0) + "%", money(k.payBefore), true)}
          ${k.credit ? line("Crédito de tu consulta", "−" + money(k.credit)) : ""}
          ${line("El día de tu última cita", money(k.balance), true)}
          <p style="margin:.5rem 0 0;color:var(--slate);font-size:.88rem">
            No hay nada que pagar en las citas intermedias.</p>
        </div>
        ${saves ? `<p style="margin:.9rem 0 0;color:#3F6B54;font-size:.95rem">
          Ahorras ${money(saves)} comparado con pagar sesión por sesión.</p>` : ""}
      `, true)}

      <details class="estopt" data-opt="opt2" style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.3rem;margin-bottom:.7rem">
        <summary style="cursor:pointer;font-weight:500;font-size:1.05rem">
          Financiado &nbsp;·&nbsp; <span style="color:var(--slate);font-weight:400">${money(k.financedTotal)} en total</span>
        </summary>
        <div style="margin-top:.9rem">
          ${line("Paquete completo", money(k.bundle))}
          ${line("Costo de financiamiento (" + (k.financingPct || 0) + "%)", money(k.fee))}
          ${k.credit ? line("Crédito de tu consulta", "−" + money(k.credit)) : ""}
          ${line("Total financiado", money(k.financedTotal), true)}
          <p style="margin:.8rem 0 0;color:var(--slate);font-size:.9rem">
            Se divide en pagos con Shop Pay al momento de reservar.</p>
        </div>
      </details>

      <details class="estopt" data-opt="opt3" style="border:1px solid var(--mist);background:var(--white);border-radius:4px;padding:1.1rem 1.3rem;margin-bottom:1.5rem">
        <summary style="cursor:pointer;font-weight:500;font-size:1.05rem">
          Sesión por sesión &nbsp;·&nbsp; <span style="color:var(--slate);font-weight:400">${money(k.separate != null ? k.separate : k.separateNet)} en total</span>
        </summary>
        <div style="margin-top:.9rem">
          ${items.map(x => line(`${x.n} × ${esc(x.label)}`, money(x.total))).join("")}
          ${line("1 × " + esc(d.service || "día principal"), money(k.mainPrice))}
          ${k.credit ? line("Crédito de tu consulta", "−" + money(k.credit)) : ""}
          ${line("Total", money(k.separateNet), true)}
          <p style="margin:.8rem 0 0;color:var(--slate);font-size:.9rem">
            Pagas cada cita por separado. Es la opción más flexible y la más costosa.</p>
        </div>
      </details>`;
  };

  const tabs = tiers.length < 2 ? "" : `
    <div style="display:flex;gap:.4rem;margin-bottom:1rem;flex-wrap:wrap">
      ${tiers.map((t, i) => `<button class="btn ghost" data-tier="${i}"
        style="flex:1 1 10rem">${esc(t.label || ("Opción " + (i + 1)))}</button>`).join("")}
    </div>`;

  estShell(`
    <header class="mast">
      <div class="salon">${esc(CONFIG.salonName.toUpperCase())}</div>
      <h1 class="mark">Hola,<br><em>${esc(d.firstName || "")}.</em></h1>
    </header>

    <p class="stepnote" style="font-size:1.05rem">
      Este es tu estimado personalizado para tu <b>${esc(d.service || "")}</b>${
        d.consultDate ? ` — después de tu consulta del ${esc(d.consultDate)}${
          d.consultWith ? ` con ${esc(d.consultWith)}` : ""}` : ""}.
    </p>

    ${d.evalText ? card(`<h4 style="font-family:Newsreader,Georgia,serif;font-size:1.2rem;margin:0 0 .6rem">
        Lo que vimos en tu cabello</h4>
      <p style="margin:0;line-height:1.7">${esc(d.evalText)}</p>`) : ""}

    ${hl ? `<div style="display:flex;gap:.6rem;flex-wrap:wrap;margin-bottom:1.2rem">${hl}</div>` : ""}

    ${includes ? `<h3 class="sec-h">Tu plan incluye</h3>
      ${card(`<ul style="margin:0;padding-left:1.1rem;line-height:1.6">${includes}</ul>`)}` : ""}

    <h3 class="sec-h">Tu inversión</h3>
    <p class="stepnote">${tiers.length > 1
      ? "Puedes hacerlo con cualquiera de nuestras dos estilistas. Toca una para ver sus precios."
      : "Tres formas de hacerlo. Elige la que mejor te funcione."}</p>
    ${tabs}
    <div id="estmoney"></div>

    ${d.closing ? `<p style="line-height:1.7;margin:0 0 1.5rem">${esc(d.closing)}</p>` : ""}

    <a class="btn" id="estreserve" href="${esc(EST.reserveUrl)}" target="_blank" rel="noopener"
       style="display:inline-block;text-decoration:none;font-size:1.1rem;padding:1rem 2.2rem">
      Reservar mi cita</a>

    <p class="stepnote" style="margin:1.5rem 0 0;font-size:.9rem">
      Este estimado es personal y está basado en tu evaluación. Si tu cabello cambia antes de empezar,
      lo revisamos juntas. Cualquier duda, escríbenos.</p>
  `);

  let cur = 0;
  const paint = () => {
    $("#estmoney").innerHTML = moneyHTML(cur);
    $$("[data-tier]").forEach(b => {
      const on = +b.dataset.tier === cur;
      b.style.background   = on ? "var(--graphite)" : "";
      b.style.color        = on ? "var(--white)" : "";
      b.style.borderColor  = on ? "var(--graphite)" : "";
    });
    $$(".estopt").forEach(dt =>
      dt.addEventListener("toggle", () => { if (dt.open) estLog(id, dt.dataset.opt); }));
  };
  paint();

  $$("[data-tier]").forEach(b => b.onclick = () => {
    cur = +b.dataset.tier;
    if (cur > 0) estLog(id, "tier2");
    paint();
  });

  estLog(id, "view");
  const rb = $("#estreserve");
  if (rb) rb.addEventListener("click", () => estLog(id, "reserve"));

}

/* ---------- boot ---------- */
route();

/* let the Shopify theme editor re-init after a section reload */
window.GHS_init = route;